(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8550],{

/***/ 16600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgAadharVerifiedProfile(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    clipPath: "url(#aadhar_verified_profile_svg__a)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M16.103 13.356a10.092 10.092 0 01-2.413 3.765 12.622 12.622 0 01-4.714 2.8 1.441 1.441 0 01-.459.08h-.016a1.462 1.462 0 01-.476-.082 12.622 12.622 0 01-4.72-2.8 10.073 10.073 0 01-2.407-3.76A21.717 21.717 0 01.02 5.447v-.036c.009-.194.015-.4.018-.622a2.122 2.122 0 011.996-2.077 8.203 8.203 0 005.59-2.36l.008-.01a1.277 1.277 0 011.736 0l.015.011a8.205 8.205 0 005.59 2.36 2.114 2.114 0 011.996 2.077c0 .226.01.43.018.622v.015a21.753 21.753 0 01-.884 7.93z",
    fill: "#FFD686"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M16.103 13.356a10.091 10.091 0 01-2.413 3.765 12.622 12.622 0 01-4.714 2.8 1.44 1.44 0 01-.458.081V-.004c.315.004.618.126.85.34l.013.012a8.205 8.205 0 005.59 2.36 2.115 2.115 0 011.996 2.077c0 .226.01.429.018.622v.019a21.755 21.755 0 01-.882 7.93z",
    fill: "#FEB72C"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M14.282 10a5.805 5.805 0 01-1.689 4.086 5.784 5.784 0 01-4.073 1.706H8.5a5.777 5.777 0 01-4.088-1.697 5.798 5.798 0 010-8.191A5.777 5.777 0 018.5 4.207h.02c1.53.007 2.994.62 4.074 1.706A5.805 5.805 0 0114.282 10z",
    fill: "#fff"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M14.281 10a5.805 5.805 0 01-1.689 4.086 5.784 5.784 0 01-4.072 1.706V4.209a5.78 5.78 0 014.072 1.705A5.805 5.805 0 0114.281 10z",
    fill: "#E0E9FF"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11.478 8.989l-2.942 2.949-.636.637a.769.769 0 01-1.088 0l-1.368-1.37a.772.772 0 01.548-1.302.77.77 0 01.54.212l.824.825 3.035-3.041a.769.769 0 011.3.55.772.772 0 01-.212.54z",
    fill: "#FEB72C"
  }))), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", {
    id: "aadhar_verified_profile_svg__a"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M0 0h17v20H0z"
  })))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgAadharVerifiedProfile);

/***/ }),

/***/ 89905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgArrowRightWhite(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 15.98 16"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M15.88 7.493a1.332 1.332 0 00-.28-.44L8.939.392a1.338 1.338 0 00-1.892 1.892l4.4 4.383H1.332a1.332 1.332 0 000 2.664h10.112l-4.4 4.383a1.338 1.338 0 101.895 1.89L15.6 8.945a1.377 1.377 0 00.28-1.452z",
    fill: "#fff"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowRightWhite);

/***/ }),

/***/ 64948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Select; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29216);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Select_styles_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82836);
/* harmony import */ var _RSelectDerived_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11350);
/* harmony import */ var _Typography_Typography_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53796);
/* harmony import */ var _constants_colors_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94897);
/* harmony import */ var _layout_Flex_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31013);









const ReactSelect = react__WEBPACK_IMPORTED_MODULE_1__.lazy(() => Promise.all(/* import() */[__webpack_require__.e(5502), __webpack_require__.e(4800)]).then(__webpack_require__.bind(__webpack_require__, 74800)));
const ReactCreatableSelect = react__WEBPACK_IMPORTED_MODULE_1__.lazy(() => Promise.all(/* import() */[__webpack_require__.e(5502), __webpack_require__.e(6473)]).then(__webpack_require__.bind(__webpack_require__, 66473)));
const Select = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((props, ref) => {
    const { id, name, label, headingLabel, headingLabelStyleProps, errorMsg, option, required, noOptionText, noOptionHandler, labelFormatter, value = null, outline = "border", menuPlacement = "auto", menuPosition = "fixed", size = "md", components } = props, restCommonProps = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_7__/* .__rest */ ._)(props, ["id", "name", "label", "headingLabel", "headingLabelStyleProps", "errorMsg", "option", "required", "noOptionText", "noOptionHandler", "labelFormatter", "value", "outline", "menuPlacement", "menuPosition", "size", "components"]);
    const commonProps = Object.assign({ "aria-label": label, name, id: `${id}__container`, inputId: `${id}__input`, instanceId: id, ref,
        value, options: option, menuPlacement,
        menuPosition, components: Object.assign({ SelectContainer: _RSelectDerived_js__WEBPACK_IMPORTED_MODULE_3__/* .ContainerComponent */ .e$, DropdownIndicator: _RSelectDerived_js__WEBPACK_IMPORTED_MODULE_3__/* .DropdownIndicatorComponent */ .fz, Control: _RSelectDerived_js__WEBPACK_IMPORTED_MODULE_3__/* .ControlComponent */ .Fr, SingleValue: _RSelectDerived_js__WEBPACK_IMPORTED_MODULE_3__/* .SingleValueComponent */ .G$, NoOptionsMessage: _RSelectDerived_js__WEBPACK_IMPORTED_MODULE_3__/* .NoOptionsMessageComponent */ .c1, Option: _RSelectDerived_js__WEBPACK_IMPORTED_MODULE_3__/* .OptionComponent */ .x8, Input: _RSelectDerived_js__WEBPACK_IMPORTED_MODULE_3__/* .InputComponent */ .am, IndicatorSeparator: null, ValueContainer: _RSelectDerived_js__WEBPACK_IMPORTED_MODULE_3__/* .ValueComponent */ .u$, Placeholder: _RSelectDerived_js__WEBPACK_IMPORTED_MODULE_3__/* .PlaceholderComponent */ .WB, ClearIndicator: _RSelectDerived_js__WEBPACK_IMPORTED_MODULE_3__/* .ClearIconComponent */ .OD }, components), noOptionsMessage: noOptionHandler !== null && noOptionHandler !== void 0 ? noOptionHandler : (() => noOptionText !== null && noOptionText !== void 0 ? noOptionText : "No Option"), formatOptionLabel: labelFormatter }, restCommonProps);
    const getElementByType = () => {
        switch (props.type) {
            case "common": {
                return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, Object.assign({ fallback: null }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReactSelect, Object.assign({}, commonProps)) })));
            }
            case "creatable": {
                const { onCreateOption, getNewOptionData, isValidNewOption, formatCreateLabel, createOptionPosition, } = props;
                const creatableProps = {
                    onCreateOption,
                    getNewOptionData,
                    isValidNewOption,
                    formatCreateLabel,
                    createOptionPosition,
                };
                return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, Object.assign({ fallback: null }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReactCreatableSelect, Object.assign({}, commonProps, creatableProps)) })));
            }
            default: {
                return null;
            }
        }
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Flex_js__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, Object.assign({ flexDirection: "column", gap: 12 }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography_Typography_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, Object.assign({ color: _constants_colors_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"].GREY_900 */ .Z.GREY_900, required: required }, headingLabelStyleProps, { children: headingLabel })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Select_styles_js__WEBPACK_IMPORTED_MODULE_2__/* .StyledSelectWrapper */ .W, Object.assign({ outline: outline, size: size }, { children: getElementByType() })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography_Typography_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, Object.assign({ color: _constants_colors_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"].RED */ .Z.RED, size: "s" }, { children: errorMsg }))] })));
});
Select.defaultProps = {
    type: "common",
};


//# sourceMappingURL=Select.js.map


/***/ }),

/***/ 82836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ StyledSelectWrapper; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(82740);
/* harmony import */ var _constants_colors_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94897);
/* harmony import */ var _constants_fonts_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12308);
/* harmony import */ var _constants_theme_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63298);
/* harmony import */ var _constants_files_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65357);
/* harmony import */ var _constants_color_variant_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60603);
/* harmony import */ var _constants_zIndexList_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94069);
/* harmony import */ var _constants_ui_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10193);
/* harmony import */ var _mixins_style_mixins_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13261);
/* harmony import */ var _mixins_scrollbar_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47755);
/* harmony import */ var _mixins_cursor_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27106);
/* harmony import */ var _mixins_font_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(79047);













const StyledSelectWrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div */ .ZP.div `
    ${(props) => {
    const size = props === null || props === void 0 ? void 0 : props.size;
    switch (size) {
        case "sm":
            return styled_components__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv `
                    height: ${_constants_ui_js__WEBPACK_IMPORTED_MODULE_6__/* .CommonElementSizeMap */ .K[size]};
                    &,
                    .select-value-container [data-select-value-label] {
                        ${(0,_mixins_font_js__WEBPACK_IMPORTED_MODULE_10__/* .getCommonFontStyleMixin */ .d)({ size })};
                    }
                `;
        default:
            return styled_components__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv `
                    font-size: 16px;
                    height: 48px;
                `;
    }
}};

    .select-container {
        height: 100%;
    }
    .select-control {
        font-size: 12px;
        height: 100%;
        outline: none;
        padding: 0 16px;
        box-shadow: none;

        ${({ outline }) => {
    switch (outline) {
        case "border":
            return styled_components__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv `
                        border: 1px solid ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_200 */ .Z.GREY_200};
                    `;
        case "underline":
            return styled_components__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv `
                        border: none;
                        border-radius: 0;
                        border-bottom: 2px solid ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_200 */ .Z.GREY_200};
                    `;
        default:
            return styled_components__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv ``;
    }
}}

        ${({ borderRadius }) => borderRadius
    ? styled_components__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv `
                      border-radius: ${borderRadius}px;
                  `
    : ""}

        &:hover {
            border-color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].BLUE */ .Z.BLUE};
        }
    }

    .select-value-container {
        padding: 0;
        overflow: hidden;
        height: 100%;
    }

    .select-singleValue {
        margin-left: 5px;
        color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_1000 */ .Z.GREY_1000};
    }

    .select-option {
        background-color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].WHITE */ .Z.WHITE};
        color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_1000 */ .Z.GREY_1000};

        &:hover {
            color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].WHITE */ .Z.WHITE};
            background-color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].BLUE */ .Z.BLUE};
        }

        &.selected,
        &.focused {
            color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].WHITE */ .Z.WHITE};
            background-color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].BLUE */ .Z.BLUE};
        }

        &.disabled {
            color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].WHITE */ .Z.WHITE};
            background-color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_600 */ .Z.GREY_600};
            cursor: not-allowed;
        }
    }

    .select-input {
        input {
            caret-color: transparent;
        }
    }

    .select-control--searchable .select-input {
        color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_1000 */ .Z.GREY_1000};
        cursor: text;

        input {
            caret-color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].BLUE */ .Z.BLUE};
            color: inherit;
            cursor: text;
            font-size: 16px;
            opacity: 1 !important;
        }
    }

    .select-placeholder {
        color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_400 */ .Z.GREY_400};
        font-family: ${_constants_fonts_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].REGULAR */ .Z.REGULAR};
        font-size: 13px;
    }

    .select-dropDownIndicator {
        svg {
            width: 18px;
            height: 18px;
            transform: rotate(90deg);
        }
    }
    .select-customDropDownIndicator {
        padding: 0;
    }

    .select-noOptionMessage {
        color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].BLUE */ .Z.BLUE};
    }

    .select-multiValue {
        background-color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_300 */ .Z.GREY_300};
        border: 2px solid ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].RED */ .Z.RED};
        padding: 2px;
    }

    .select-customDropDownIndicator,
    .select-clear {
        cursor: pointer;
    }
`;


//# sourceMappingURL=Select.styles.js.map


/***/ }),

/***/ 52585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ShowMoreText; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core-ui/dist/components/TextCTA/TextCTA.js + 1 modules
var TextCTA = __webpack_require__(3545);
// EXTERNAL MODULE: ../core-ui/dist/components/ModalOrBottomSheetWrapper/ModalOrBottomSheetWrapper.js + 2 modules
var ModalOrBottomSheetWrapper = __webpack_require__(83147);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(53796);
;// CONCATENATED MODULE: ../core-ui/dist/components/ShowMoreText/ShowMoreText.js






const ShowMoreText = (0,react.forwardRef)((props, ref) => {
    const { text = "", onClick, id, less = "see less", more = "see more", truncatedEnding = "...", limit = 24, showPopUpView, preWrapPopUpText, renderPopUpBody, popUpProps, } = props;
    const [isExpanded, setIsExpanded] = (0,react.useState)(false);
    const [isPopUpOpen, setIsPopUpOpen] = (0,react.useState)(false);
    const togglePopUp = () => {
        setIsPopUpOpen((v) => !v);
    };
    const onToggle = () => {
        if (!!onClick) {
            onClick();
        }
        else if (showPopUpView) {
            setIsPopUpOpen(true);
        }
        else {
            setIsExpanded((v) => !v);
        }
    };
    const shouldTruncateString = (text === null || text === void 0 ? void 0 : text.length) > limit;
    const truncatedString = text
        .slice(0, limit)
        .split(" ")
        .slice(0, -1)
        .join(" ");
    const ExpandActionSlot = ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: ["\u00A0", (0,jsx_runtime.jsx)(TextCTA/* default */.Z, Object.assign({ onClick: onToggle, weight: "medium", underline: true }, { children: isExpanded ? less : more }))] }));
    return ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [shouldTruncateString ? ((0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: isExpanded ? ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [text, ExpandActionSlot] })) : ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [truncatedString, truncatedEnding, "\u00A0", ExpandActionSlot] })) })) : ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [text, (props === null || props === void 0 ? void 0 : props.actionAlwaysVisible) && ExpandActionSlot] })), (0,jsx_runtime.jsx)(ModalOrBottomSheetWrapper/* default */.Z, Object.assign({ isOpen: isPopUpOpen, onToggle: togglePopUp, modalSeparationGap: 0 }, popUpProps, { children: renderPopUpBody ? (renderPopUpBody) : ((0,jsx_runtime.jsx)(Typography/* default */.Z, Object.assign({ preWrap: preWrapPopUpText }, { children: text }))) }))] }));
});


//# sourceMappingURL=ShowMoreText.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/ShowMoreText/index.js


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 3545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TextCTA; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../core-ui/dist/constants/fonts.js
var fonts = __webpack_require__(12308);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ../core-ui/dist/constants/fontSize.js
var fontSize = __webpack_require__(99420);
// EXTERNAL MODULE: ../core-ui/dist/constants/theme.js
var theme = __webpack_require__(63298);
// EXTERNAL MODULE: ../core-ui/dist/constants/files.js
var files = __webpack_require__(65357);
// EXTERNAL MODULE: ../core-ui/dist/constants/color-variant.js
var color_variant = __webpack_require__(60603);
// EXTERNAL MODULE: ../core-ui/dist/constants/zIndexList.js
var zIndexList = __webpack_require__(94069);
;// CONCATENATED MODULE: ../core-ui/dist/components/TextCTA/TextCTA.styles.js









const StyledTextCTA = styled_components_browser_esm/* default.button */.ZP.button `
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    outline: inherit;

    &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }

    color: ${({ color }) => color};
    font-family: ${({ weight }) => weight && fonts/* default */.Z[weight.toUpperCase()]};
    display: inline-flex;
    align-items: center;
    gap: 2px;
    line-height: 1.5;
    font-size: ${({ size }) => (size ? `${fontSize/* default */.Z[size]}rem` : "inherit")};
    text-decoration: ${({ underline }) => underline && "underline"};
    text-underline-offset: 2px;
`;


//# sourceMappingURL=TextCTA.styles.js.map

// EXTERNAL MODULE: ../core-ui/dist/hooks/useGenericAsyncHandler.js
var useGenericAsyncHandler = __webpack_require__(20475);
;// CONCATENATED MODULE: ../core-ui/dist/components/TextCTA/TextCTA.js






const TextCTA = (0,react.forwardRef)((props, ref) => {
    const { children, disabled, color = colors/* default.BLUE */.Z.BLUE, id, weight = "bold", iconNode, size = "s", underline, type = "button", } = props;
    const asynHandler = (0,useGenericAsyncHandler/* useGenericAsyncHandler */.L)(props === null || props === void 0 ? void 0 : props.onClick);
    return ((0,jsx_runtime.jsxs)(StyledTextCTA, Object.assign({ id: id, color: color, weight: weight, size: size, disabled: disabled || (asynHandler === null || asynHandler === void 0 ? void 0 : asynHandler.loading), underline: underline, type: type }, ((props === null || props === void 0 ? void 0 : props.onClick) && {
        onClick: asynHandler === null || asynHandler === void 0 ? void 0 : asynHandler.execute,
    }), { children: [iconNode, " ", children] })));
});


//# sourceMappingURL=TextCTA.js.map


/***/ }),

/***/ 14342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _TextCTA_js__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _TextCTA_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3545);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 49986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AppRadioBtn; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var reactstrap_lib_Input__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72445);
/* harmony import */ var reactstrap_lib_Label__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3879);




const AppRadioBtn = ({ id, name, labelText, value, isChecked, onChange, style, className, labelClassName, inputClassName }) => {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { style: Object.assign(Object.assign({ display: "inline-flex", alignItems: "center", height: "22px", fontSize: "1rem", letterSpacing: "-0.01rem", cursor: "pointer" }, style), { marginLeft: `calc(${(style === null || style === void 0 ? void 0 : style.marginLeft) || "0px"} + 22px)` }), className: className },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(reactstrap_lib_Label__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { check /* for={name} */: true, style: { margin: 0, cursor: "pointer" }, className: labelClassName },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(reactstrap_lib_Input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { id: id, type: "radio", name: name, value: value, checked: isChecked, onChange: onChange, style: {
                    height: "22px",
                    width: "22px",
                    margin: 0,
                    cursor: "pointer",
                    marginLeft: "calc(-22px - 9px)"
                }, className: inputClassName }),
            labelText)));
};


//# sourceMappingURL=AppRadioBtn.js.map


/***/ }),

/***/ 53679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ResponsiveContainer; }
});

// EXTERNAL MODULE: ../core/dist/_virtual/_tslib.js
var _tslib = __webpack_require__(30116);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../core/dist/node_modules/style-inject/dist/style-inject.es.js
var style_inject_es = __webpack_require__(36474);
;// CONCATENATED MODULE: ../core/dist/components/responsive-container/ResponsiveContainer.module.scss.js


var css_248z = ".ResponsiveContainer-module_container_box__vbXde {\n  display: flex;\n  flex-wrap: wrap;\n}";
var Styles = {"container_box":"ResponsiveContainer-module_container_box__vbXde"};
(0,style_inject_es/* default */.Z)(css_248z);


//# sourceMappingURL=ResponsiveContainer.module.scss.js.map

;// CONCATENATED MODULE: ../core/dist/components/responsive-container/ResponsiveContainer.js





const ResponsiveContainer = (_a) => {
    var { className, id } = _a, props = (0,_tslib/* __rest */._)(_a, ["className", "id"]);
    return (react.createElement("div", { id: id, className: classnames_default()(Styles.container_box, className) }, props.children));
};


//# sourceMappingURL=ResponsiveContainer.js.map


/***/ }),

/***/ 78645:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/transporters/[[...params]]",
      function () {
        return __webpack_require__(71220);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _seo_header_PageSeo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83347);
/* harmony import */ var _methods_pageSeo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61706);
/* harmony import */ var _vahak_core_dist_constants_platformStats__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28230);






var getCityMetaDescription = function(cityName) {
    return "Book ".concat(_vahak_core_dist_constants_platformStats__WEBPACK_IMPORTED_MODULE_5__/* .PLATFORM_STATS.liveLoadsAndLorries.label */ .s.liveLoadsAndLorries.label, " loads and lorries in ").concat(cityName, "! Vahak is the #1 platform for ").concat(cityName, " transport services. Join India's largest transporter network today for free.");
};
/**
 * Registers page SEO with the global SeoProvider.
 * Rendering is handled by GlobalSeoHead in _app — route defaults live in methods/pageSeo.ts.
 */ var PageMetaTags = function(param) {
    var cityName = param.cityName, titleProp = param.title, descriptionProp = param.description, _keywords = param.keywords, keywords = _keywords === void 0 ? "" : _keywords, asPath = param.asPath, locale = param.locale, localeNeutralPath = param.localeNeutralPath, hreflangLocales = param.hreflangLocales, canonicalUrlProp = param.canonicalUrl, ogUrl = param.ogUrl, ogDescription = param.ogDescription, _ogImgSrc = param.ogImgSrc, ogImgSrc = _ogImgSrc === void 0 ? (0,_methods_pageSeo__WEBPACK_IMPORTED_MODULE_4__/* .getDefaultOgImage */ .av)() : _ogImgSrc, ogImgAltTextProp = param.ogImgAltText, ogType = param.ogType, ogSiteName = param.ogSiteName, schema = param.schema, schemaOrgJsonUrlProp = param.schemaOrgJsonUrl, _includeDefaultSchema = param.includeDefaultSchema, includeDefaultSchema = _includeDefaultSchema === void 0 ? false : _includeDefaultSchema, _shouldBeIndexed = param.shouldBeIndexed, shouldBeIndexed = _shouldBeIndexed === void 0 ? true : _shouldBeIndexed, breadcrumbList = param.breadcrumbList, _schemaType = param.schemaType, schemaType = _schemaType === void 0 ? "WebPage" : _schemaType, faqList = param.faqList, children = param.children;
    var title = titleProp !== null && titleProp !== void 0 ? titleProp : cityName ? "Vahak - Book Best Transport Services in ".concat(cityName) : undefined;
    var description = descriptionProp !== null && descriptionProp !== void 0 ? descriptionProp : cityName ? getCityMetaDescription(cityName) : undefined;
    var canonicalUrl = canonicalUrlProp !== null && canonicalUrlProp !== void 0 ? canonicalUrlProp : cityName ? "https://www.vahak.in/city/".concat(cityName) : undefined;
    var schemaOrgJsonUrl = schemaOrgJsonUrlProp !== null && schemaOrgJsonUrlProp !== void 0 ? schemaOrgJsonUrlProp : cityName ? "/city/".concat(cityName) : undefined;
    var ogImgAltText = ogImgAltTextProp !== null && ogImgAltTextProp !== void 0 ? ogImgAltTextProp : description;
    var seoConfig = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            title: title,
            description: description,
            keywords: keywords,
            asPath: asPath,
            locale: locale,
            localeNeutralPath: localeNeutralPath,
            hreflangLocales: hreflangLocales,
            canonicalUrl: asPath ? undefined : canonicalUrl,
            ogUrl: ogUrl,
            ogDescription: ogDescription,
            ogImgSrc: ogImgSrc,
            ogImgAltText: ogImgAltText,
            ogType: ogType,
            ogSiteName: ogSiteName,
            schema: schema,
            schemaOrgJsonUrl: schemaOrgJsonUrl,
            includeDefaultSchema: includeDefaultSchema,
            shouldBeIndexed: shouldBeIndexed,
            breadcrumbList: breadcrumbList,
            schemaType: schemaType,
            faqList: faqList
        };
    }, [
        title,
        description,
        keywords,
        asPath,
        locale,
        localeNeutralPath,
        hreflangLocales,
        canonicalUrl,
        ogUrl,
        ogDescription,
        ogImgSrc,
        ogImgAltText,
        ogType,
        ogSiteName,
        schema,
        schemaOrgJsonUrl,
        includeDefaultSchema,
        shouldBeIndexed,
        breadcrumbList,
        schemaType,
        faqList
    ]);
    (0,_seo_header_PageSeo__WEBPACK_IMPORTED_MODULE_3__/* .useRegisterPageSeo */ .C9)(seoConfig);
    if (!children) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageMetaTags);


/***/ }),

/***/ 9740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(96670);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4628);
/* harmony import */ var _MandateServiceType_module_scss__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(40769);
/* harmony import */ var _MandateServiceType_module_scss__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_MandateServiceType_module_scss__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _vahak_core_ui_dist_components_ModalOrBottomSheetWrapper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9937);
/* harmony import */ var _vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71960);
/* harmony import */ var _constants_serviceTypeOption__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(28343);
/* harmony import */ var _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94204);
/* harmony import */ var _vahak_core_dist_services_hooks_useEventTrackerService__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10182);
/* harmony import */ var _vahak_core_dist_methods_sleep__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(37007);
/* harmony import */ var _utils_AppImg__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(17073);
/* harmony import */ var _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69406);
/* harmony import */ var _vahak_core_dist_constants_market__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(45678);








//Context

//Styles

//Components


//Constants

//Services






var MandateServiceType = function(param) {
    var isLoggedIn = param.isLoggedIn, initialServiceType = param.initialServiceType, handleServiceTypeChange = param.handleServiceTypeChange, source = param.source;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_5__/* .AppContext */ .Il), isPhoneVerified = ref.isPhoneVerified, companyId = ref.companyId, serviceType = ref.serviceType, setServiceType = ref.setServiceType, csDashboardUserRoles = ref.csDashboardUserRoles;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var routerHash = router.asPath.split("#").slice(1)[0];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isMandateServiceTypeOpen = ref1[0], setIsMandateServiceTypeOpen = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(serviceType), selectedServiceType = ref2[0], setSelectedServiceType = ref2[1];
    var ChangeServiceType = routerHash === "changeServiceType";
    var sendGAandMoEngageEvent = (0,_vahak_core_dist_services_hooks_useEventTrackerService__WEBPACK_IMPORTED_MODULE_10__/* .useEventTrackerService */ .f)().sendGAandMoEngageEvent;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (serviceType) setSelectedServiceType(serviceType);
        //Base check - force open service type selection on user request
        if (csDashboardUserRoles) {
            return;
        }
        if (ChangeServiceType) {
            setIsMandateServiceTypeOpen(true);
            return;
        }
        if (isPhoneVerified && companyId && isLoggedIn || serviceType && initialServiceType || serviceType) {
            setIsMandateServiceTypeOpen(false);
        } else {
            setIsMandateServiceTypeOpen(true);
        }
    }, [
        router,
        isLoggedIn,
        isPhoneVerified,
        companyId,
        serviceType,
        initialServiceType
    ]);
    var trackEventOnServiceTypeChange = function(selection, isLoadMkt) {
        sendGAandMoEngageEvent({
            name: _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_13__/* .GA4EventNames.MARKET_PLACE.preference_selected */ .wQ.MARKET_PLACE.preference_selected,
            data: {
                source_screen: isLoadMkt ? "load_market" : "lorry_market",
                selection: selection
            }
        });
    };
    var handleClickServiceType = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(value) {
            var ref, mktQuery, isLoadMkt;
            return _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        mktQuery = (ref = router.query["params"]) === null || ref === void 0 ? void 0 : ref[0];
                        isLoadMkt = mktQuery === _vahak_core_dist_constants_market__WEBPACK_IMPORTED_MODULE_14__/* .MARKET_TYPE.LOAD */ .X5.LOAD;
                        setSelectedServiceType === null || setSelectedServiceType === void 0 ? void 0 : setSelectedServiceType(value);
                        _ctx.next = 6;
                        return (0,_vahak_core_dist_methods_sleep__WEBPACK_IMPORTED_MODULE_11__/* .sleep */ ._)(150);
                    case 6:
                        setServiceType === null || setServiceType === void 0 ? void 0 : setServiceType(value);
                        setIsMandateServiceTypeOpen(false);
                        _ctx.next = 10;
                        return router.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, router), {
                            hash: undefined
                        }));
                    case 10:
                        _ctx.t0 = value;
                        _ctx.next = _ctx.t0 === _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_9__/* .CompanyServiceType.SHIPPER */ .AAU.SHIPPER ? 13 : _ctx.t0 === _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_9__/* .CompanyServiceType.FLEET_OWNER */ .AAU.FLEET_OWNER ? 16 : 19;
                        break;
                    case 13:
                        handleServiceTypeChange === null || handleServiceTypeChange === void 0 ? void 0 : handleServiceTypeChange("lorry");
                        trackEventOnServiceTypeChange("find_lorries", isLoadMkt);
                        return _ctx.abrupt("break", 22);
                    case 16:
                        handleServiceTypeChange === null || handleServiceTypeChange === void 0 ? void 0 : handleServiceTypeChange("load");
                        trackEventOnServiceTypeChange("find_loads", isLoadMkt);
                        return _ctx.abrupt("break", 22);
                    case 19:
                        trackEventOnServiceTypeChange("find_loads_lorries", isLoadMkt);
                        handleServiceTypeChange === null || handleServiceTypeChange === void 0 ? void 0 : handleServiceTypeChange("load");
                        return _ctx.abrupt("break", 22);
                    case 22:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleClickServiceType(value) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_ui_dist_components_ModalOrBottomSheetWrapper__WEBPACK_IMPORTED_MODULE_6__["default"], {
            isOpen: isMandateServiceTypeOpen,
            showCloseIcon: false,
            onToggle: function() {},
            renderTitle: true,
            modalSize: "fit",
            blurBackground: true,
            disableSheetOverlayClick: true,
            disableSheetSwipe: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: (_MandateServiceType_module_scss__WEBPACK_IMPORTED_MODULE_18___default().ServiceTypeModalBodyWrapper),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: (_MandateServiceType_module_scss__WEBPACK_IMPORTED_MODULE_18___default().headingWrapper),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                size: "l",
                                as: "p",
                                weight: "bold",
                                children: "What are you looking for?"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                size: "m",
                                as: "p",
                                children: "Select below option accordingly"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: (_MandateServiceType_module_scss__WEBPACK_IMPORTED_MODULE_18___default().serviceTypeWrapper),
                        children: _constants_serviceTypeOption__WEBPACK_IMPORTED_MODULE_8__/* .ServiceTypeOptions.map */ .w.map(function(param, index) {
                            var lookingForLabel = param.lookingForLabel, lookingForIcon = param.lookingForIcon, value = param.value, lookingForAlternative = param.lookingForAlternative;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                id: "select-service-type-".concat(index),
                                className: classnames__WEBPACK_IMPORTED_MODULE_4___default()((_MandateServiceType_module_scss__WEBPACK_IMPORTED_MODULE_18___default().serviceTypeCard), selectedServiceType === value ? (_MandateServiceType_module_scss__WEBPACK_IMPORTED_MODULE_18___default().active) : ""),
                                onClick: function() {
                                    return handleClickServiceType(value);
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utils_AppImg__WEBPACK_IMPORTED_MODULE_12__["default"], {
                                        src: lookingForIcon,
                                        width: "65px",
                                        height: "65px"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        children: source === "transport_directory" ? lookingForAlternative : lookingForLabel
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MandateServiceType);


/***/ }),

/***/ 96080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ breadcrumbsConstants; }
/* harmony export */ });
function breadcrumbsConstants(param) {
    var mktType = param.mktType, city = param.city;
    var breadcrumbs = {
        onlineLoadBooking: '[\n            {\n                "@type": "ListItem", \n                "position": 1, \n                "name": "Home",\n                "item": "https://www.vahak.in/"  \n            },\n            {\n                "@type": "ListItem", \n                "position": 2, \n                "name": "Load Booking",\n                "item": "https://www.vahak.in/online-load-booking"  \n            }\n        ]',
        onlineLorryBooking: '[\n            {\n                "@type": "ListItem", \n                "position": 1, \n                "name": "Home",\n                "item": "https://www.vahak.in/"  \n            },\n            {\n                "@type": "ListItem", \n                "position": 2, \n                "name": "Truck Booking",\n                "item": "https://www.vahak.in/online-truck-booking"  \n            }\n        ]',
        growNetwork: '[\n            {\n                "@type": "ListItem", \n                "position": 1, \n                "name": "Home",\n                "item": "https://www.vahak.in/"  \n            },\n            {\n                "@type": "ListItem", \n                "position": 2, \n                "name": "Grow Transport Buisness",\n                "item": "https://www.vahak.in/grow-network"  \n            }\n        ]',
        logisticsServices: '[\n            {\n                "@type": "ListItem", \n                "position": 1, \n                "name": "Home",\n                "item": "https://www.vahak.in/"  \n            },\n            {\n                "@type": "ListItem", \n                "position": 2, \n                "name": "Logistics Services",\n                "item": "https://www.vahak.in/logistics-services"  \n            }\n        ]',
        fullTruckLoad: '[\n            {\n                "@type": "ListItem", \n                "position": 1, \n                "name": "Home",\n                "item": "https://www.vahak.in/"  \n            },\n            {\n                "@type": "ListItem", \n                "position": 2, \n                "name": "Full Truck Load",\n                "item": "https://www.vahak.in/full-truck-load"  \n            }\n        ]',
        partTruckLoad: '[\n            {\n                "@type": "ListItem", \n                "position": 1, \n                "name": "Home",\n                "item": "https://www.vahak.in/"  \n            },\n            {\n                "@type": "ListItem", \n                "position": 2, \n                "name": "Part Load Booking",\n                "item": "https://www.vahak.in/part-load-booking"  \n            }\n        ]',
        marketplace: '[\n            {\n                "@type": "ListItem", \n                "position": 1, \n                "name": "Home",\n                "item": "https://www.vahak.in/"  \n            },\n            {\n                "@type": "ListItem", \n                "position": 2, \n                "name": "'.concat(mktType, ' Marketplace",\n                "item": "https://www.vahak.in/marketplace/').concat(mktType, '/"  \n            }  \n        ]'),
        transportDirectory: '[\n            {\n                "@type": "ListItem", \n                "position": 1, \n                "name": "Home",\n                "item": "https://www.vahak.in/"  \n            },\n            {\n                "@type": "ListItem", \n                "position": 2, \n                "name": "Transporters",\n                "item": "https://www.vahak.in/transporters"  \n            }\n        ]',
        transportDirectoryLocation: '[\n            {\n                "@type": "ListItem", \n                "position": 1, \n                "name": "Home",\n                "item": "https://www.vahak.in/"  \n            },\n            {\n                "@type": "ListItem", \n                "position": 2, \n                "name": "Transporters",\n                "item": "https://www.vahak.in/transporters"  \n            },\n            {\n                "@type": "ListItem", \n                "position": 3, \n                "name": "'.concat(city, '",\n                "item": "https://www.vahak.in/transporters/').concat(city, '"  \n            }\n        ]'),
        membershipUpgrade: '[\n            {\n                "@type": "ListItem",\n                "position": 1,\n                "name": "Home",\n                "item": "https://www.vahak.in/"\n            },\n            {\n                "@type": "ListItem",\n                "position": 2,\n                "name": "Membership",\n                "item": "https://www.vahak.in/membership/upgrade"\n            }\n        ]',
        cargoInsurance: '[\n            {\n                "@type": "ListItem",\n                "position": 1,\n                "name": "Home",\n                "item": "https://www.vahak.in/"\n            },\n            {\n                "@type": "ListItem",\n                "position": 2,\n                "name": "Cargo Insurance",\n                "item": "https://www.vahak.in/vas/cargo-insurance"\n            }\n        ]',
        cityPages: '[\n            {\n                "@type": "ListItem", \n                "position": 1, \n                "name": "Home",\n                "item": "https://www.vahak.in/"  \n            },\n            {\n                "@type": "ListItem", \n                "position": 2, \n                "name": "'.concat(city, '",\n                "item": "https://www.vahak.in/city/').concat(city, '"  \n            }\n        ]')
    };
    return breadcrumbs;
}


/***/ }),

/***/ 71220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ TransporterSearch; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react-loading-skeleton/lib/index.js
var lib = __webpack_require__(51992);
// EXTERNAL MODULE: ../../node_modules/react-stickynode/dist/es/Sticky.js + 11 modules
var Sticky = __webpack_require__(36977);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ../core/dist/methods/capitalize.js
var capitalize = __webpack_require__(10478);
// EXTERNAL MODULE: ../core/dist/methods/getRemValue.js
var getRemValue = __webpack_require__(89842);
// EXTERNAL MODULE: ./components/transporter/search/search.module.scss
var search_module = __webpack_require__(12753);
var search_module_default = /*#__PURE__*/__webpack_require__.n(search_module);
// EXTERNAL MODULE: ../core/dist/constants/link.js
var constants_link = __webpack_require__(39422);
// EXTERNAL MODULE: ../core/dist/constants/routeStrings.js
var routeStrings = __webpack_require__(12098);
// EXTERNAL MODULE: ../core/dist/components/Pagination/pagination.js
var pagination = __webpack_require__(5288);
// EXTERNAL MODULE: ../core/dist/components/Pagination/BottomPagination.js
var BottomPagination = __webpack_require__(79393);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../core/dist/hooks/useSearch.js
var useSearch = __webpack_require__(32099);
;// CONCATENATED MODULE: ./components/transporter/search/constants.ts
var PopularDest = [
    {
        state_id: 1,
        state: "Maharashtra"
    },
    {
        state_id: 4,
        state: "Gujarat"
    },
    {
        state_id: 2,
        state: "Delhi"
    },
    {
        state_id: 3,
        state: "Karnataka"
    }
];

// EXTERNAL MODULE: ../core/dist/hooks/useTopDest.js
var useTopDest = __webpack_require__(75206);
;// CONCATENATED MODULE: ../core/dist/icons/SearchBlue.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgSearchBlue(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 18.014 18"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M17.761 16.483l-3.34-3.313a8.1 8.1 0 10-1.251 1.251l3.313 3.313a.894.894 0 101.278-1.251zm-9.64-2.062a6.3 6.3 0 116.3-6.3 6.3 6.3 0 01-6.3 6.3z",
    fill: "#3b52ff"
  })));
}

/* harmony default export */ var SearchBlue = (SvgSearchBlue);
;// CONCATENATED MODULE: ../core/dist/icons/EditBlue.svg
var EditBlue_path;

function EditBlue_extends() { EditBlue_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return EditBlue_extends.apply(this, arguments); }



function SvgEditBlue(props) {
  return /*#__PURE__*/react.createElement("svg", EditBlue_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.294,
    height: 14.294,
    viewBox: "0 0 14.294 14.294"
  }, props), EditBlue_path || (EditBlue_path = /*#__PURE__*/react.createElement("path", {
    d: "M13.575 7.149a.714.714 0 00-.714.714v4.287a.715.715 0 01-.714.715h-10a.714.714 0 01-.714-.715v-10a.714.714 0 01.714-.714H6.43a.715.715 0 100-1.43H2.143A2.143 2.143 0 000 2.148v10a2.143 2.143 0 002.143 2.143h10a2.143 2.143 0 002.143-2.143V7.864a.714.714 0 00-.711-.715zm-10.717.543v3.029a.714.714 0 00.714.714H6.6a.714.714 0 00.507-.207l4.944-4.951 2.029-1.986a.714.714 0 000-1.015L11.053.212a.714.714 0 00-1.015 0L8.024 2.234 3.065 7.185a.715.715 0 00-.207.507zm7.688-5.966l2.022 2.022-1.015 1.015-2.022-2.022zM4.287 7.985l4.237-4.237 2.022 2.022-4.237 4.236H4.287z",
    fill: "#1053ff"
  })));
}

/* harmony default export */ var EditBlue = (SvgEditBlue);
;// CONCATENATED MODULE: ../core/dist/icons/CloseCircle.svg
var CloseCircle_path;

function CloseCircle_extends() { CloseCircle_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return CloseCircle_extends.apply(this, arguments); }



function SvgCloseCircle(props) {
  return /*#__PURE__*/react.createElement("svg", CloseCircle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 24 24"
  }, props), CloseCircle_path || (CloseCircle_path = /*#__PURE__*/react.createElement("path", {
    d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm4.853 15.439a.5.5 0 010 .707l-.707.707a.5.5 0 01-.707 0L12 13.414l-3.439 3.439a.5.5 0 01-.707 0l-.707-.707a.5.5 0 010-.707L10.586 12 7.147 8.561a.5.5 0 010-.707l.707-.707a.5.5 0 01.707 0L12 10.586l3.439-3.439a.5.5 0 01.707 0l.707.707a.5.5 0 010 .707L13.414 12z",
    fill: "#646464",
    opacity: 0.6
  })));
}

/* harmony default export */ var CloseCircle = (SvgCloseCircle);
// EXTERNAL MODULE: ./components/transporter/search/mobile-search-card/MobileSearchCard.module.scss
var MobileSearchCard_module = __webpack_require__(8827);
var MobileSearchCard_module_default = /*#__PURE__*/__webpack_require__.n(MobileSearchCard_module);
// EXTERNAL MODULE: ./components/transporter/search/quick-filter-pill/QuickFilterPill.module.scss
var QuickFilterPill_module = __webpack_require__(43154);
var QuickFilterPill_module_default = /*#__PURE__*/__webpack_require__.n(QuickFilterPill_module);
;// CONCATENATED MODULE: ./components/transporter/search/quick-filter-pill/QuickFilterPill.tsx




function QuickFilterPill(param) {
    var text = param.text, prefix = param.prefix, suffix = param.suffix, isMobile = param.isMobile, className = param.className, selectedClassName = param.selectedClassName, prefixClassName = param.prefixClassName, suffixClassName = param.suffixClassName, _isSelected = param.isSelected, isSelected = _isSelected === void 0 ? false : _isSelected, onSelected = param.onSelected, onDeselected = param.onDeselected, data = param.data;
    var _onSelected = function() {
        onSelected === null || onSelected === void 0 ? void 0 : onSelected(data);
    };
    var _onDeselected = function() {
        onDeselected === null || onDeselected === void 0 ? void 0 : onDeselected(data);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((QuickFilterPill_module_default()).container, isSelected && (QuickFilterPill_module_default()).selected, isSelected && selectedClassName, isMobile ? (QuickFilterPill_module_default()).mobile : (QuickFilterPill_module_default()).desktop, className),
        onClick: isSelected ? _onDeselected : _onSelected,
        children: [
            prefix && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: classnames_default()((QuickFilterPill_module_default()).prefix, prefixClassName),
                children: prefix
            }),
            text && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "quickFilterPill__text",
                children: text
            }),
            suffix && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: classnames_default()((QuickFilterPill_module_default()).suffix, suffixClassName),
                children: suffix
            })
        ]
    });
}
/* harmony default export */ var quick_filter_pill_QuickFilterPill = (QuickFilterPill);

// EXTERNAL MODULE: ./components/transporter/search/CloseBtn.module.scss
var CloseBtn_module = __webpack_require__(45446);
var CloseBtn_module_default = /*#__PURE__*/__webpack_require__.n(CloseBtn_module);
;// CONCATENATED MODULE: ./components/transporter/search/mobile-search-card/MobileSearchCard.tsx










var MobileSearchCard = function(param) {
    var nameSearchVal = param.nameSearchVal, onClearName = param.onClearName, sourceSearchLabelKey = param.sourceSearchLabelKey, onClickSearchSource = param.onClickSearchSource, selectedSource = param.selectedSource, onClearSrc = param.onClearSrc, topDests = param.topDests, selectedDest = param.selectedDest, onClickDestQuickFilter = param.onClickDestQuickFilter, onClickDestSearchBtn = param.onClickDestSearchBtn, onDeselectDestSearchBtn = param.onDeselectDestSearchBtn, isCardMinimized = param.isCardMinimized, onClickEdit = param.onClickEdit, searchBy = param.searchBy, className = param.className;
    var ref = (0,react.useState)(false), isInEditMode = ref[0], setIsInEditMode = ref[1];
    // const onBlurDestinationSearch = useCallback(() => {
    //     if (!destinationSearchSelectedItem) {
    //         setDestSearchVisible(false);
    //         setDestSearchClear((state) => state + 1);
    //         // setDestSearchInputVal("");
    //     }
    // }, [destinationSearchSelectedItem]);
    var _onClearSrc = function(e) {
        e.stopPropagation();
        onClearSrc === null || onClearSrc === void 0 ? void 0 : onClearSrc();
    };
    var _onClearName = function(e) {
        e.stopPropagation();
        onClearName === null || onClearName === void 0 ? void 0 : onClearName();
    };
    (0,react.useEffect)(function() {
        setIsInEditMode(isCardMinimized && !!(selectedSource || selectedDest || nameSearchVal));
    }, [
        isCardMinimized,
        nameSearchVal,
        selectedSource,
        selectedDest
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((MobileSearchCard_module_default()).transporters__mobile_search__container, isCardMinimized && (MobileSearchCard_module_default()).minimized, searchBy === "name" && (MobileSearchCard_module_default()).minimized),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (MobileSearchCard_module_default()).transporters__mobile_search__source_search_btn,
                    onClick: !isInEditMode ? searchBy === "name" ? onClickEdit : onClickSearchSource : undefined,
                    children: isInEditMode ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((MobileSearchCard_module_default()).editContainer, searchBy === "name" && (MobileSearchCard_module_default()).nameEditContainer),
                        onClick: onClickEdit,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (MobileSearchCard_module_default()).currentSelections,
                                children: [
                                    searchBy === "location" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (MobileSearchCard_module_default()).selectedSrc,
                                                children: selectedSource ? sourceSearchLabelKey(selectedSource) : "Where is your Loading Point?"
                                            }),
                                            selectedDest && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (MobileSearchCard_module_default()).selectedDest,
                                                children: [
                                                    "Going towards ",
                                                    selectedDest.state
                                                ]
                                            })
                                        ]
                                    }),
                                    searchBy === "name" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (MobileSearchCard_module_default()).nameSearchVal__Container,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBlue, {}),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (MobileSearchCard_module_default()).nameSearch,
                                                children: nameSearchVal || "Search"
                                            }),
                                            nameSearchVal && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (CloseBtn_module_default()).btn,
                                                style: {
                                                    position: "absolute",
                                                    right: "32px"
                                                },
                                                onClick: _onClearName,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseCircle, {})
                                            })
                                        ]
                                    })
                                ]
                            }),
                            searchBy === "location" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (MobileSearchCard_module_default()).editBtn,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EditBlue, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Edit"
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBlue, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (MobileSearchCard_module_default()).transporters__mobile_search__source_search_btn__text,
                                children: searchBy === "location" ? selectedSource && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        sourceSearchLabelKey(selectedSource),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (CloseBtn_module_default()).btn,
                                            style: {
                                                marginLeft: "20px"
                                            },
                                            onClick: _onClearSrc,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseCircle, {})
                                        })
                                    ]
                                }) || "Where is your Loading Point?" : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        nameSearchVal || "Search",
                                        nameSearchVal && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (CloseBtn_module_default()).btn,
                                            style: {
                                                position: "absolute",
                                                right: "32px"
                                            },
                                            onClick: _onClearName,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseCircle, {
                                                height: "18"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                !isCardMinimized && searchBy === "location" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (MobileSearchCard_module_default()).transporters__mobile_search__dest_container,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (MobileSearchCard_module_default()).transporters__mobile_search__dest_label,
                            children: "Destination State"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (MobileSearchCard_module_default()).dest_search_control,
                            children: [
                                topDests.slice(0, 2).map(function(state) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(quick_filter_pill_QuickFilterPill, {
                                        text: state === null || state === void 0 ? void 0 : state.state,
                                        className: (MobileSearchCard_module_default()).dest__quick_filter,
                                        isMobile: true,
                                        isSelected: (state === null || state === void 0 ? void 0 : state.state_id) === ((selectedDest === null || selectedDest === void 0 ? void 0 : selectedDest.state_id) || (selectedDest === null || selectedDest === void 0 ? void 0 : selectedDest.id)),
                                        onSelected: onClickDestQuickFilter,
                                        onDeselected: onDeselectDestSearchBtn,
                                        data: state,
                                        selectedClassName: (MobileSearchCard_module_default()).selectedStateFilterPill
                                    }, state === null || state === void 0 ? void 0 : state.state_id);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(quick_filter_pill_QuickFilterPill, {
                                    prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBlue, {
                                        height: 12,
                                        width: 12
                                    }),
                                    className: (MobileSearchCard_module_default()).dest_search_icon_container,
                                    prefixClassName: (MobileSearchCard_module_default()).dest_search_icon,
                                    onSelected: onClickDestSearchBtn,
                                    isMobile: true
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var mobile_search_card_MobileSearchCard = (MobileSearchCard);

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 7 modules
var esm = __webpack_require__(42386);
// EXTERNAL MODULE: ../core-ui/dist/hooks/useMediaQuery.js
var useMediaQuery = __webpack_require__(26513);
;// CONCATENATED MODULE: ./components/transporter/search/Cover.tsx







var Cover = function(param) {
    var className = param.className, _isMinimized = param.isMinimized, isMinimized = _isMinimized === void 0 ? false : _isMinimized, style = param.style, cityName = param.cityName;
    var t = (0,esm/* useTranslation */.$G)([
        "transporters"
    ]).t;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), isPhoneVerified = ref.isPhoneVerified, companyId = ref.companyId;
    var mobileScreen = (0,useMediaQuery/* default */.Z)({
        queryType: "mobile"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        style: (0,src_object_spread/* default */.Z)({
            width: "100%",
            backgroundColor: "#08123B",
            textAlign: "center",
            color: "#FFFFFF",
            paddingTop: isPhoneVerified && companyId ? mobileScreen ? "20px" : "10px" : mobileScreen ? "55px" : "10px"
        }, style),
        children: !isMinimized && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                height: mobileScreen ? undefined : "141px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    style: {
                        fontSize: mobileScreen ? (0,getRemValue/* getRemValue */.T)(22) : (0,getRemValue/* getRemValue */.T)(40),
                        lineHeight: mobileScreen ? (0,getRemValue/* getRemValue */.T)(22) : (0,getRemValue/* getRemValue */.T)(40)
                    },
                    children: cityName ? "India's #1 Transporters in ".concat(cityName) : t("transporter_cover.heading")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    style: {
                        fontSize: mobileScreen ? (0,getRemValue/* getRemValue */.T)(18) : (0,getRemValue/* getRemValue */.T)(32),
                        fontFamily: "var(--font-medium)",
                        marginTop: "2px"
                    },
                    children: t("transporter_cover.sub_heading")
                })
            ]
        })
    });
};
/* harmony default export */ var search_Cover = (Cover);

// EXTERNAL MODULE: ../../node_modules/reactstrap/es/Modal.js + 3 modules
var Modal = __webpack_require__(31258);
// EXTERNAL MODULE: ../../node_modules/reactstrap/es/ModalBody.js
var ModalBody = __webpack_require__(3743);
// EXTERNAL MODULE: ../core/dist/components/app-radio-btn/AppRadioBtn.js
var AppRadioBtn = __webpack_require__(49986);
;// CONCATENATED MODULE: ../core/dist/icons/GreyPlus.svg
var GreyPlus_path;

function GreyPlus_extends() { GreyPlus_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return GreyPlus_extends.apply(this, arguments); }



function SvgGreyPlus(props) {
  return /*#__PURE__*/react.createElement("svg", GreyPlus_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), GreyPlus_path || (GreyPlus_path = /*#__PURE__*/react.createElement("path", {
    d: "M11.25 5.25h-4.5V.75a.75.75 0 10-1.5 0v4.5H.75a.75.75 0 100 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5z",
    fill: "#80868b"
  })));
}

/* harmony default export */ var GreyPlus = (SvgGreyPlus);
;// CONCATENATED MODULE: ../core/dist/icons/CheckBlack.svg
var CheckBlack_path;

function CheckBlack_extends() { CheckBlack_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return CheckBlack_extends.apply(this, arguments); }



function SvgCheckBlack(props) {
  return /*#__PURE__*/react.createElement("svg", CheckBlack_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 8,
    viewBox: "0 0 11 8"
  }, props), CheckBlack_path || (CheckBlack_path = /*#__PURE__*/react.createElement("path", {
    d: "M10.747.232a.783.783 0 00-1.111 0L3.805 6.07l-2.45-2.458A.8.8 0 10.244 4.763l3.005 3.005a.783.783 0 001.111 0l6.387-6.382a.783.783 0 000-1.151z"
  })));
}

/* harmony default export */ var CheckBlack = (SvgCheckBlack);
// EXTERNAL MODULE: ./components/transporter/search/edit-search-modal/EditSearchModal.module.scss
var EditSearchModal_module = __webpack_require__(16313);
var EditSearchModal_module_default = /*#__PURE__*/__webpack_require__.n(EditSearchModal_module);
// EXTERNAL MODULE: ../core/dist/components/app-btn/AppBtn.js + 2 modules
var AppBtn = __webpack_require__(49995);
// EXTERNAL MODULE: ../core/dist/components/app-input/AppInput.js
var AppInput = __webpack_require__(90650);
// EXTERNAL MODULE: ../core/dist/constants/misc.js
var misc = __webpack_require__(77370);
;// CONCATENATED MODULE: ./components/transporter/search/edit-search-modal/EditSearchModal.tsx


















var EditSearchModal = function(param) {
    var isVisible = param.isVisible, handleToggle = param.handleToggle, nameSearchVal = param.nameSearchVal, onInputNameSearch = param.onInputNameSearch, onClearName = param.onClearName, sourceSearchLabelKey = param.sourceSearchLabelKey, selectedSource = param.selectedSource, onClearSrc = param.onClearSrc, onClickSearchSource = param.onClickSearchSource, topDests = param.topDests, selectedDest = param.selectedDest, onClickDestQuickFilter = param.onClickDestQuickFilter, onDeselectDestSearchBtn = param.onDeselectDestSearchBtn, onClickDestSearchBtn = param.onClickDestSearchBtn, onClickUpdateSearch = param.onClickUpdateSearch, searchBy = param.searchBy, onChangeSearchBy = param.onChangeSearchBy;
    // const location = useLocation();
    var _onClearSrc = function(e) {
        e.stopPropagation();
        onClearSrc === null || onClearSrc === void 0 ? void 0 : onClearSrc();
    };
    var _onClearName = function(e) {
        e.stopPropagation();
        onClearName === null || onClearName === void 0 ? void 0 : onClearName();
    };
    // useEffect(() => {
    //     location.state = undefined;
    // }, []);
    (0,react.useEffect)(function() {
        (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (isVisible) {
                            document.body.style.overflow = "hidden";
                            if (window.scrollY !== 0) {
                                window.scrollTo({
                                    left: 0,
                                    top: 0,
                                    behavior: "auto"
                                });
                            }
                            document.querySelector(".sticky-inner-wrapper").classList.add("inactive");
                        } else {
                            document.body.style.overflow = "unset";
                            document.querySelector(".sticky-inner-wrapper").classList.remove("inactive");
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        isOpen: isVisible,
        backdrop: true,
        keyboard: true,
        unmountOnClose: true,
        toggle: handleToggle,
        className: (EditSearchModal_module_default()).container,
        modalClassName: "EditSearchModal__modal",
        contentClassName: (EditSearchModal_module_default()).content,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBody/* default */.Z, {
            className: (EditSearchModal_module_default()).body,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (EditSearchModal_module_default()).searchBy,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (EditSearchModal_module_default()).label,
                            children: "Search Transporters"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (EditSearchModal_module_default()).searchByRadioBtns,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AppRadioBtn/* default */.Z, {
                                    labelText: "By Location",
                                    name: "serachBy",
                                    value: "location",
                                    isChecked: searchBy === "location",
                                    className: (EditSearchModal_module_default()).locationRadioBtn,
                                    inputClassName: (EditSearchModal_module_default()).radioBtn__input,
                                    labelClassName: (EditSearchModal_module_default()).radioBtn__label,
                                    onChange: onChangeSearchBy
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AppRadioBtn/* default */.Z, {
                                    labelText: "By Name",
                                    name: "serachBy",
                                    value: "name",
                                    isChecked: searchBy === "name",
                                    className: (EditSearchModal_module_default()).nameRadioBtn,
                                    inputClassName: (EditSearchModal_module_default()).radioBtn__input,
                                    labelClassName: (EditSearchModal_module_default()).radioBtn__label,
                                    onChange: onChangeSearchBy
                                })
                            ]
                        })
                    ]
                }),
                searchBy === "location" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (EditSearchModal_module_default()).src,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (EditSearchModal_module_default()).label,
                                    children: "Source Location"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((EditSearchModal_module_default()).srcSearchBtn__Text, !selectedSource && (EditSearchModal_module_default()).placeholder),
                                    onClick: onClickSearchSource,
                                    children: selectedSource && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            sourceSearchLabelKey(selectedSource),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (CloseBtn_module_default()).btn,
                                                onClick: _onClearSrc,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseCircle, {})
                                            })
                                        ]
                                    }) || "Where is your Loading Point?"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (EditSearchModal_module_default()).dest,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (EditSearchModal_module_default()).label,
                                    children: "Destination State"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (EditSearchModal_module_default()).dest_search_control,
                                    children: [
                                        topDests.slice(0, 2).map(function(state) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(quick_filter_pill_QuickFilterPill, {
                                                text: state === null || state === void 0 ? void 0 : state.state,
                                                suffix: (state === null || state === void 0 ? void 0 : state.state_id) === (selectedDest === null || selectedDest === void 0 ? void 0 : selectedDest.state_id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBlack, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(GreyPlus, {}),
                                                className: (EditSearchModal_module_default()).dest__quick_filter,
                                                isMobile: true,
                                                isSelected: (state === null || state === void 0 ? void 0 : state.state_id) === (selectedDest === null || selectedDest === void 0 ? void 0 : selectedDest.state_id),
                                                onSelected: onClickDestQuickFilter,
                                                onDeselected: onDeselectDestSearchBtn,
                                                data: state
                                            }, state === null || state === void 0 ? void 0 : state.state_id);
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(quick_filter_pill_QuickFilterPill, {
                                            prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBlue, {
                                                height: 12,
                                                width: 12
                                            }),
                                            className: (EditSearchModal_module_default()).search_icon_container,
                                            prefixClassName: (EditSearchModal_module_default()).search_icon,
                                            onSelected: onClickDestSearchBtn,
                                            isMobile: true
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                searchBy === "name" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (EditSearchModal_module_default()).nameSearch,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (EditSearchModal_module_default()).label,
                            children: "Transporter Name"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (EditSearchModal_module_default()).nameSearch__Container,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AppInput/* default */.Z, {
                                    isActiveByDefault: true,
                                    labelText: "",
                                    value: nameSearchVal,
                                    name: "searchByName",
                                    type: "text",
                                    onChange: onInputNameSearch,
                                    containerStyles: {
                                        border: "none",
                                        height: "auto"
                                    },
                                    inputWrapperStyles: {
                                        padding: 0
                                    },
                                    inputStyles: {
                                        color: "#1053FF",
                                        fontSize: (0,getRemValue/* getRemValue */.T)(16),
                                        letterSpacing: (0,getRemValue/* getRemValue */.T)(-0.16),
                                        fontWeight: misc/* FONT_WEIGHTS.medium */.Xw.medium,
                                        lineHeight: (0,getRemValue/* getRemValue */.T)(20),
                                        padding: 0
                                    },
                                    autoComplete: false
                                }),
                                (nameSearchVal === null || nameSearchVal === void 0 ? void 0 : nameSearchVal.trim()) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (CloseBtn_module_default()).btn,
                                    onClick: _onClearName,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseCircle, {})
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(quick_filter_pill_QuickFilterPill, {
                                    prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBlue, {
                                        height: 12,
                                        width: 12
                                    }),
                                    className: (EditSearchModal_module_default()).search_icon_container,
                                    prefixClassName: (EditSearchModal_module_default()).search_icon,
                                    isMobile: true
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBtn/* default */.Z, {
                    className: (EditSearchModal_module_default()).submitBtn,
                    isMobile: true,
                    width: "140px",
                    onClick: onClickUpdateSearch,
                    children: "Update Search"
                })
            ]
        })
    });
};
/* harmony default export */ var edit_search_modal_EditSearchModal = (EditSearchModal);

// EXTERNAL MODULE: ../core/dist/methods/getSizeByViewPort.js
var getSizeByViewPort = __webpack_require__(98175);
// EXTERNAL MODULE: ../core/dist/components/search-full-screen-mobile/SearchFullScreenMobile.js + 3 modules
var SearchFullScreenMobile = __webpack_require__(87890);
// EXTERNAL MODULE: ../core/dist/_services/city-search.service.js
var city_search_service = __webpack_require__(20803);
;// CONCATENATED MODULE: ./components/transporter/search/mobile/Mobile.tsx















var formattedPopularDest = PopularDest.map(function(state) {
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
        category: "suggested",
        categoryLabel: "POPULAR DESTINATIONS"
    });
});
var Mobile = function(param) {
    var isSearchCardMinimized = param.isSearchCardMinimized, className = param.className, topContainerClassName = param.topContainerClassName, searchCardClassName = param.searchCardClassName, searchBy = param.searchBy, src = param.src, onSelectSrc = param.onSelectSrc, onClearSrc = param.onClearSrc, dest = param.dest, onSelectDest = param.onSelectDest, selectedDestQuickFilter = param.selectedDestQuickFilter, nameSearchVal = param.nameSearchVal, onClearName = param.onClearName, onClickUpdateSearch = param.onClickUpdateSearch, isSrcSearchVisible = param.isSrcSearchVisible, setisSrcSearchVisible = param.setisSrcSearchVisible, isDestSearchVisible = param.isDestSearchVisible, setisDestSearchVisible = param.setisDestSearchVisible, isEditSearchModalVisible = param.isEditSearchModalVisible, setisEditSearchModalVisible = param.setisEditSearchModalVisible, srcParam = param.srcParam;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), currentLocation = ref.currentLocation, recentTransporterCitySearches = ref.recentTransporterCitySearches;
    var ref1 = (0,useTopDest/* useTopDest */.p)({
        max: 2
    }), topDests = ref1.topDests, setTopDests = ref1.setTopDests;
    var ref2 = (0,react.useState)({
        name: ""
    }), editSearchVals = ref2[0], updateEditSearchVals = ref2[1];
    var onChangeEditSearchBy = function(e) {
        e.persist();
        var val = e.currentTarget.value;
        updateEditSearchVals(function(state) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                searchBy: val
            });
        });
    };
    var onChangeEditSrc = function(selected) {
        updateEditSearchVals(function(state) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                src: selected
            });
        });
        setisSrcSearchVisible(false);
    };
    var onChangeEditDest = function(selected) {
        updateEditSearchVals(function(state) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                dest: selected
            });
        });
        if (isDestSearchVisible) {
            setisDestSearchVisible(false);
        }
    };
    var onChangeEditName = function(e) {
        e.persist();
        var name = e.currentTarget.value;
        updateEditSearchVals(function(state) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                name: name
            });
        });
    };
    var onClearEditSrc = function() {
        updateEditSearchVals(function(state) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                src: undefined
            });
        });
    };
    var onClearEditName = function() {
        updateEditSearchVals(function(state) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                name: ""
            });
        });
    };
    var ref3 = (0,useSearch/* usePlaceSearch */.A)({
        locationParamsOption: {
            source: city_search_service/* LocationSearchSource.TransporterProfile */.T5.TransporterProfile
        },
        showCurrentLocationOption: true,
        defaultOptions: recentTransporterCitySearches,
        onSelectItem: function(selectedItems) {
            isEditSearchModalVisible ? onChangeEditSrc(selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems[0]) : onSelectSrc(selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems[0]);
        }
    }), isSourceSearchLoading = ref3.isSearchLoading, setIsSourceSearchLoading = ref3.setIsSearchLoading, onSourceSearchInput = ref3.onSearchInput, sourceSearchOptions = ref3.searchOptions, sourceSearchText = ref3.searchText, sourceSearchLabelKey = ref3.labelKey, onSourceSearchInputChange = ref3.onInputChange, onSourceSearchItemSelected = ref3.onItemSelected, selectedSrcInSearch = ref3.selectedItem, setSelectedSrcInSearch = ref3.setSelectedItem;
    var ref4 = (0,useSearch/* useStateSearch */.k)({
        locationParamsOption: {
            source: city_search_service/* LocationSearchSource.TransporterProfile */.T5.TransporterProfile
        },
        showCurrentLocationOption: true,
        defaultOptions: formattedPopularDest,
        onSelectItem: function(item) {
            setTopDests(item[0]);
            isEditSearchModalVisible ? onChangeEditDest(item[0]) : onSelectDest(item[0]);
        }
    }), destSearchLabelKey = ref4.labelKey, isDestSearchLoading = ref4.isSearchLoading, onDestSearchInput = ref4.onSearchInput, destSearchOptions = ref4.searchOptions, destSearchText = ref4.searchText, onDestSearchInputChange = ref4.onInputChange, onDestSearchItemSelected = ref4.onItemSelected, selectedDestInSearch = ref4.selectedItem, setSelectedDestInSearch = ref4.setSelectedItem;
    var onClickSearchSource = function() {
        setisSrcSearchVisible(true);
        setSelectedSrcInSearch(undefined);
    };
    var onClickDestSearchBtn = function() {
        setisDestSearchVisible(true);
        setSelectedDestInSearch(undefined);
    };
    var onClickSourceSearchBackBtn = function() {
        setisSrcSearchVisible(false);
    };
    var onClickDestSearchBackBtn = function() {
        setisDestSearchVisible(false);
    };
    var onClickDestQuickFilter = function(state) {
        isEditSearchModalVisible ? onChangeEditDest(state) : onSelectDest(state);
        setSelectedDestInSearch(state);
        setTopDests(state);
    };
    var onDeselectDestQuickFilter = function() {
        isEditSearchModalVisible ? onChangeEditDest(undefined) : onSelectDest(undefined);
        setSelectedDestInSearch(undefined);
    };
    var onClickEditSearch = function() {
        setisEditSearchModalVisible(true);
    };
    var onToggleEditSearchModal = function() {
        setisEditSearchModalVisible(!isEditSearchModalVisible);
    };
    var _onClickUpdateSearch = function() {
        window.scrollTo({
            left: 0,
            top: +(0,getSizeByViewPort/* getHeightByViewPort */.J)(74).slice(0, -2),
            behavior: "auto"
        });
        onClickUpdateSearch(editSearchVals);
    };
    (0,react.useEffect)(function() {
        if (currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.lat) {
            setSelectedSrcInSearch({
                name: String(currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.lat)
            });
        }
        setIsSourceSearchLoading(false);
    }, [
        currentLocation
    ]);
    (0,react.useEffect)(function() {
        selectedDestQuickFilter.state_id && setTopDests(selectedDestQuickFilter);
    }, [
        selectedDestQuickFilter
    ]);
    (0,react.useEffect)(function() {
        isEditSearchModalVisible && updateEditSearchVals({
            searchBy: searchBy,
            src: src,
            dest: dest,
            name: nameSearchVal
        });
    }, [
        isEditSearchModalVisible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()(topContainerClassName),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(search_Cover, {
                        isMinimized: isSearchCardMinimized,
                        style: {
                        },
                        cityName: srcParam
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("container", searchCardClassName),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_search_card_MobileSearchCard, {
                            isCardMinimized: isSearchCardMinimized,
                            searchBy: searchBy,
                            nameSearchVal: nameSearchVal,
                            sourceSearchLabelKey: sourceSearchLabelKey,
                            selectedSource: src,
                            onClearSrc: onClearSrc,
                            onClickSearchSource: onClickSearchSource,
                            topDests: topDests,
                            selectedDest: dest,
                            onClickDestQuickFilter: onClickDestQuickFilter,
                            onDeselectDestSearchBtn: onDeselectDestQuickFilter,
                            onClickDestSearchBtn: onClickDestSearchBtn,
                            onClickEdit: onClickEditSearch,
                            onClearName: onClearName
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFullScreenMobile/* default */.Z, {
                isVisible: !!isSrcSearchVisible,
                onClickBackBtn: onClickSourceSearchBackBtn,
                id: "transporter-source-search",
                isLoading: isSourceSearchLoading,
                onSearch: onSourceSearchInput,
                onSelectItem: onSourceSearchItemSelected,
                onInputChange: onSourceSearchInputChange,
                selectedItem: selectedSrcInSearch,
                options: sourceSearchOptions,
                searchText: sourceSearchText,
                labelText: "",
                labelKey: sourceSearchLabelKey,
                placeholder: "Where is your Loading Point?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFullScreenMobile/* default */.Z, {
                isVisible: !!isDestSearchVisible,
                onClickBackBtn: onClickDestSearchBackBtn,
                id: "transporter-dest-search",
                isLoading: isDestSearchLoading,
                onSearch: onDestSearchInput,
                onSelectItem: onDestSearchItemSelected,
                onInputChange: onDestSearchInputChange,
                selectedItem: selectedDestInSearch,
                options: destSearchOptions,
                searchText: destSearchText,
                labelText: "",
                labelKey: destSearchLabelKey,
                placeholder: "Search Destination State"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(edit_search_modal_EditSearchModal, {
                isVisible: !!isEditSearchModalVisible,
                handleToggle: onToggleEditSearchModal,
                nameSearchVal: editSearchVals.name,
                onInputNameSearch: onChangeEditName,
                onClearName: onClearEditName,
                sourceSearchLabelKey: sourceSearchLabelKey,
                selectedSource: editSearchVals.src,
                onClearSrc: onClearEditSrc,
                onClickSearchSource: onClickSearchSource,
                topDests: topDests,
                selectedDest: editSearchVals.dest,
                onClickDestQuickFilter: onClickDestQuickFilter,
                onClickDestSearchBtn: onClickDestSearchBtn,
                onDeselectDestSearchBtn: onDeselectDestQuickFilter,
                onClickUpdateSearch: _onClickUpdateSearch,
                searchBy: editSearchVals.searchBy,
                onChangeSearchBy: onChangeEditSearchBy
            })
        ]
    });
};
/* harmony default export */ var mobile_Mobile = (Mobile);

// EXTERNAL MODULE: ../core/dist/components/search/Search.js + 65 modules
var Search = __webpack_require__(81528);
// EXTERNAL MODULE: ./components/transporter/search/DesktopSearchCard.module.scss
var DesktopSearchCard_module = __webpack_require__(67005);
var DesktopSearchCard_module_default = /*#__PURE__*/__webpack_require__.n(DesktopSearchCard_module);
;// CONCATENATED MODULE: ./components/transporter/search/DesktopSearchCard.tsx






// import { getHeightByViewPort,getWidthByViewPort } from "@vahak/core/dist/methods/getSizeByViewPort";












var DesktopSearchCard_PopularDest = [
    {
        state: "Maharashtra",
        category: "suggested",
        categoryLabel: "POPULAR DESTINATIONS"
    },
    {
        state: "Rajasthan",
        category: "suggested",
        categoryLabel: "POPULAR DESTINATIONS"
    },
    {
        state: "Tamil Nadu",
        category: "suggested",
        categoryLabel: "POPULAR DESTINATIONS"
    }
];
var DesktopSearchCard = function(param) {
    var isSearchCardMinimized = param.isSearchCardMinimized, searchBy = param.searchBy, onChangeSearchBy = param.onChangeSearchBy, src = param.src, onSelectSrc = param.onSelectSrc, dest = param.dest, onSelectDest = param.onSelectDest, selectedDestQuickFilter = param.selectedDestQuickFilter, nameSearchVal = param.nameSearchVal, onInputNameSearch = param.onInputNameSearch, onClearName = param.onClearName;
    var t = (0,esm/* useTranslation */.$G)([
        "transporters"
    ]).t;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), currentLocation = ref.currentLocation, recentTransporterCitySearches = ref.recentTransporterCitySearches;
    var ref1 = (0,useTopDest/* useTopDest */.p)({
        max: 4
    }), _topDests = ref1.topDests, setTopDests = ref1.setTopDests;
    var ref2 = (0,react.useState)(false), isDestinationSearchVisible = ref2[0], setDestinationSearchVisible = ref2[1];
    var ref3 = (0,react.useState)(0), destSearchClear = ref3[0], setDestSearchClear = ref3[1];
    var ref4 = (0,useSearch/* usePlaceSearch */.A)({
        locationParamsOption: {
            source: city_search_service/* LocationSearchSource.TransporterProfile */.T5.TransporterProfile
        },
        showCurrentLocationOption: true,
        defaultOptions: recentTransporterCitySearches,
        onSelectItem: function(selectedItems) {
            onSelectSrc(selectedItems[0]);
        }
    }), isSourceSearchLoading = ref4.isSearchLoading, setIsSourceSearchLoading = ref4.setIsSearchLoading, onSourceSearchInput = ref4.onSearchInput, sourceSearchOptions = ref4.searchOptions, setSrcSearchOptions = ref4.setSearchOptions, sourceSearchText = ref4.searchText, sourceSearchLabelKey = ref4.labelKey, onSourceSearchInputChange = ref4.onInputChange, onSourceSearchItemSelected = ref4.onItemSelected, // selectedItem: selectedSource,
    setSelectedSource = ref4.setSelectedItem;
    var ref5 = (0,useSearch/* useStateSearch */.k)({
        locationParamsOption: {
            source: city_search_service/* LocationSearchSource.TransporterProfile */.T5.TransporterProfile
        },
        showCurrentLocationOption: true,
        defaultOptions: DesktopSearchCard_PopularDest,
        onSelectItem: function(item) {
            setDestinationSearchVisible(false);
            if (item[0]) {
                var destState = {
                    state: item[0].name,
                    state_id: item[0].id
                };
                onSelectDest(destState);
                setTopDests(destState);
            }
        }
    }), destinationSearchLabelKey = ref5.labelKey, isDestinationSearchLoading = ref5.isSearchLoading, onDestinationSearchInput = ref5.onSearchInput, destinationSearchOptions = ref5.searchOptions, destinationSearchText = ref5.searchText, onDestinationSearchInputChange = ref5.onInputChange, onDestinationSearchItemSelected = ref5.onItemSelected, destinationSearchSelectedItem = ref5.selectedItem, setSelectedDest = ref5.setSelectedItem;
    var onClickDestinationSearchBtn = (0,react.useCallback)(function() {
        setSelectedDest(undefined);
        setDestinationSearchVisible(true);
    }, []);
    var onBlurDestinationSearch = (0,react.useCallback)(function() {
        if (!destinationSearchSelectedItem) {
            setDestinationSearchVisible(false);
            setDestSearchClear(function(state) {
                return state + 1;
            });
        // setDestSearchInputVal("");
        }
    }, [
        destinationSearchSelectedItem
    ]);
    var onClickDestQuickFilter = function(selectedItem) {
        setSelectedDest(selectedItem);
        onSelectDest(selectedItem);
        setTopDests(selectedItem);
    };
    var onDeselectDestQuickFilter = function() {
        setSelectedDest(undefined);
        onSelectDest(undefined);
    // setTopDests(selectedItem);
    };
    var _onClearName = function(e) {
        e.stopPropagation();
        onClearName === null || onClearName === void 0 ? void 0 : onClearName();
    };
    (0,react.useEffect)(function() {
        (currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.lat) && setSelectedSource({
            name: String(currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.lat)
        });
        setIsSourceSearchLoading(false);
    }, [
        currentLocation
    ]);
    (0,react.useEffect)(function() {
        recentTransporterCitySearches && setSrcSearchOptions(recentTransporterCitySearches);
    }, [
        recentTransporterCitySearches
    ]);
    (0,react.useEffect)(function() {
        selectedDestQuickFilter.state_id && setTopDests(selectedDestQuickFilter);
    }, [
        selectedDestQuickFilter
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            height: isSearchCardMinimized ? "100px" : "150px",
            boxShadow: "0px 10px 20px #CDCDCD29",
            backgroundColor: "white",
            position: "relative",
            padding: isSearchCardMinimized ? "0 67px" : "0 30px",
            marginTop: !isSearchCardMinimized ? "-75px" : "unset"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "search-by",
                style: {
                    position: "absolute",
                    top: "20px"
                },
                hidden: isSearchCardMinimized,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            // fontWeight: FONT_WEIGHTS.bold,
                            fontSize: (0,getRemValue/* getRemValue */.T)(20),
                            color: "#202124",
                            fontFamily: "Inter-Bold"
                        },
                        children: t("header_filter_section.search_transporters_label")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppRadioBtn/* default */.Z, {
                        labelText: t("header_filter_section.search_by.location"),
                        name: "serachBy",
                        value: "location",
                        isChecked: searchBy === "location",
                        style: {
                            marginLeft: "50.67px"
                        },
                        onChange: onChangeSearchBy
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppRadioBtn/* default */.Z, {
                        labelText: t("header_filter_section.search_by.name"),
                        name: "serachBy",
                        value: "name",
                        isChecked: searchBy === "name",
                        style: {
                            marginLeft: "43px"
                        },
                        onChange: onChangeSearchBy
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "search-controls",
                style: {
                    display: "flex",
                    position: "absolute",
                    width: isSearchCardMinimized ? "calc(100% - 2*16px)" : "calc(100% - 60px)",
                    bottom: isSearchCardMinimized ? "8px" : searchBy === "location" ? "10px" : "10px"
                },
                children: [
                    searchBy === "location" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "source-search",
                        style: {
                            borderRight: "1px solid rgba(128, 134, 139, 0.2)",
                            width: isSearchCardMinimized ? "418.5px" : "390px",
                            paddingRight: "20px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                            id: "transporter-source-search",
                            isLoading: isSourceSearchLoading,
                            onSearch: onSourceSearchInput,
                            onSelectItem: onSourceSearchItemSelected,
                            onInputChange: onSourceSearchInputChange,
                            selectedItem: src,
                            options: sourceSearchOptions,
                            searchText: sourceSearchText,
                            labelText: t("header_filter_section.source_city.title"),
                            labelKey: sourceSearchLabelKey,
                            labelClassName: (DesktopSearchCard_module_default()).srcSearchLabel,
                            activeClassName: (DesktopSearchCard_module_default()).activeSrc,
                            dirtyClassName: (DesktopSearchCard_module_default()).dirtySrc,
                            labelStyles: {
                                left: 0,
                                padding: 0,
                                color: "#202124",
                                fontSize: "".concat((0,getRemValue/* getRemValue */.T)(18)),
                                top: "4px",
                                // fontWeight: FONT_WEIGHTS.bold,
                                fontFamily: "var(--font-semiBold)",
                                lineHeight: "10px",
                                letterSpacing: 0
                            },
                            // setFocus={1}
                            placeholder: t("header_filter_section.source_city.placeholder"),
                            containerStyles: {
                                height: "73px",
                                border: "none"
                            },
                            inputWrapperStyles: {
                                padding: "0",
                                fontSize: (0,getRemValue/* getRemValue */.T)(22),
                                letterSpacing: (0,getRemValue/* getRemValue */.T)(-0.22),
                                fontWeight: misc/* FONT_WEIGHTS.normal */.Xw.normal,
                                marginTop: "12px"
                            },
                            inputWrapperClassName: isSearchCardMinimized ? "srcSearch__Sticky" : "srcSearch",
                            minLength: 0,
                            showClearBtn: true
                        })
                    }),
                    searchBy === "location" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "destination-search",
                        style: {
                            paddingLeft: "20px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                                id: "transporter-destination-search",
                                isLoading: isDestinationSearchLoading,
                                onSearch: onDestinationSearchInput,
                                onSelectItem: onDestinationSearchItemSelected,
                                selectedItem: destinationSearchSelectedItem,
                                onInputChange: onDestinationSearchInputChange,
                                options: destinationSearchOptions,
                                searchText: destinationSearchText,
                                labelKey: destinationSearchLabelKey,
                                labelText: t("header_filter_section.destination_state.title"),
                                labelStyles: {
                                    left: 0,
                                    padding: 0,
                                    color: "#202124",
                                    fontSize: "".concat((0,getRemValue/* getRemValue */.T)(18)),
                                    top: "4px",
                                    // fontWeight: FONT_WEIGHTS.bold,
                                    fontFamily: "var(--font-semiBold)",
                                    lineHeight: "10px",
                                    letterSpacing: 0
                                },
                                placeholder: t("header_filter_section.destination_state.placeholder"),
                                setFocus: isDestinationSearchVisible ? 1 : 0,
                                containerStyles: {
                                    width: "280px",
                                    height: "73px",
                                    border: "none"
                                },
                                inputWrapperStyles: {
                                    padding: "0",
                                    fontSize: (0,getRemValue/* getRemValue */.T)(22),
                                    letterSpacing: (0,getRemValue/* getRemValue */.T)(-0.22),
                                    fontWeight: misc/* FONT_WEIGHTS.normal */.Xw.normal,
                                    marginTop: "12px",
                                    position: "absolute",
                                    display: !isDestinationSearchVisible ? "none" : undefined,
                                    // display: "none",
                                    backgroundColor: "white"
                                },
                                inputWrapperClassName: classnames_default()(isDestinationSearchVisible ? "destination-search_input-wrapper" : "destination-search_input-wrapper_disappear", isSearchCardMinimized ? "destSearch__Sticky" : "destSearch"),
                                onBlur: onBlurDestinationSearch,
                                clear: destSearchClear
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    height: "42px",
                                    lineHeight: "42px",
                                    marginTop: "-50px",
                                    position: "absolute",
                                    display: "flex",
                                    // display: !isDestinationSearchVisible ? "inline-flex" : "none",
                                    alignItems: "center"
                                },
                                className: !isDestinationSearchVisible ? "destination-shortcut-chips" : "destination-shortcut-chips_disappear",
                                children: [
                                    _topDests.slice(0, 4).map(function(state) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(quick_filter_pill_QuickFilterPill, {
                                            text: state === null || state === void 0 ? void 0 : state.state,
                                            isMobile: false,
                                            isSelected: (state === null || state === void 0 ? void 0 : state.state_id) === ((dest === null || dest === void 0 ? void 0 : dest.state_id) || (dest === null || dest === void 0 ? void 0 : dest.id)),
                                            onSelected: onClickDestQuickFilter,
                                            onDeselected: onDeselectDestQuickFilter,
                                            className: (DesktopSearchCard_module_default()).dest_search_quick_filter,
                                            data: state,
                                            selectedClassName: (DesktopSearchCard_module_default()).selectedStateFilterPill
                                        }, state === null || state === void 0 ? void 0 : state.state_id);
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            borderRadius: "29px",
                                            backgroundColor: "rgba(12, 126, 255, 0.1)",
                                            border: "1px solid transparent",
                                            padding: "9.4px 20px",
                                            fontSize: (0,getRemValue/* getRemValue */.T)(14),
                                            letterSpacing: (0,getRemValue/* getRemValue */.T)(-0.14),
                                            color: "#1053FF",
                                            lineHeight: "18px",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            fontFamily: "var(--font-medium)"
                                        },
                                        onClick: onClickDestinationSearchBtn,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBlue, {
                                                style: {
                                                    marginRight: "9px"
                                                }
                                            }),
                                            t("header_filter_section.search_button_label")
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    searchBy === "name" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (DesktopSearchCard_module_default()).nameSearch,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                style: {
                                    // left: 0,
                                    // padding: 0,
                                    color: "#202124",
                                    fontSize: "".concat((0,getRemValue/* getRemValue */.T)(18)),
                                    // top: "4px",
                                    // fontWeight: FONT_WEIGHTS.bold,
                                    fontFamily: "var(--font-semiBold)",
                                    lineHeight: "10px",
                                    letterSpacing: 0
                                },
                                children: t("header_filter_section.search_by_name.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppInput/* default */.Z, {
                                isActiveByDefault: true,
                                placeholder: t("header_filter_section.search_by_name.placeholder"),
                                value: nameSearchVal,
                                labelText: "",
                                name: "nameSearch",
                                onChange: onInputNameSearch,
                                type: "text",
                                containerStyles: {
                                    width: "100%",
                                    border: "none"
                                },
                                inputWrapperStyles: {
                                    padding: 0,
                                    marginTop: "-9px"
                                },
                                inputStyles: {
                                    fontSize: (0,getRemValue/* getRemValue */.T)(22),
                                    letterSpacing: (0,getRemValue/* getRemValue */.T)(-0.22),
                                    fontWeight: misc/* FONT_WEIGHTS.medium */.Xw.medium,
                                    color: "#1053FF"
                                },
                                autoComplete: false,
                                valueSuffix: (nameSearchVal === null || nameSearchVal === void 0 ? void 0 : nameSearchVal.trim()) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (CloseBtn_module_default()).btn,
                                    style: {
                                        marginLeft: "auto"
                                    },
                                    onClick: _onClearName,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseCircle, {})
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var search_DesktopSearchCard = (DesktopSearchCard);

;// CONCATENATED MODULE: ./components/transporter/search/desktop/Desktop.tsx





var Desktop = function(param) {
    var isSearchCardMinimized = param.isSearchCardMinimized, searchBy = param.searchBy, onChangeSearchBy = param.onChangeSearchBy, src = param.src, onSelectSrc = param.onSelectSrc, dest = param.dest, onSelectDest = param.onSelectDest, selectedDestQuickFilter = param.selectedDestQuickFilter, nameSearchVal = param.nameSearchVal, onInputNameSearch = param.onInputNameSearch, onClearName = param.onClearName, className = param.className, topContainerClassName = param.topContainerClassName, coverClassName = param.coverClassName, searchCardClassName = param.searchCardClassName, srcParam = param.srcParam;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()(topContainerClassName),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(search_Cover, {
                    className: classnames_default()(coverClassName),
                    style: {
                        height: "220px"
                    },
                    cityName: srcParam
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("container", searchCardClassName),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(search_DesktopSearchCard, {
                        isSearchCardMinimized: isSearchCardMinimized,
                        src: src,
                        onSelectSrc: onSelectSrc,
                        dest: dest,
                        onSelectDest: onSelectDest,
                        selectedDestQuickFilter: selectedDestQuickFilter,
                        nameSearchVal: nameSearchVal,
                        onInputNameSearch: onInputNameSearch,
                        searchBy: searchBy,
                        onChangeSearchBy: onChangeSearchBy,
                        onClearName: onClearName
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var desktop_Desktop = (Desktop);

// EXTERNAL MODULE: ../core/dist/methods/getCurrentState.js
var getCurrentState = __webpack_require__(43221);
// EXTERNAL MODULE: ../core/dist/methods/sleep.js
var sleep = __webpack_require__(37007);
// EXTERNAL MODULE: ../core/dist/components/responsive-container/ResponsiveContainer.js + 1 modules
var ResponsiveContainer = __webpack_require__(53679);
// EXTERNAL MODULE: ../core/dist/_services/user-analytics.service.js
var user_analytics_service = __webpack_require__(8880);
// EXTERNAL MODULE: ../core/dist/constants/event-names.js
var event_names = __webpack_require__(69406);
// EXTERNAL MODULE: ./components/cards/transporter-card/TransporterCard.module.scss
var TransporterCard_module = __webpack_require__(46953);
var TransporterCard_module_default = /*#__PURE__*/__webpack_require__.n(TransporterCard_module);
// EXTERNAL MODULE: ../core/dist/components/cards/base-card/BaseCard.js + 1 modules
var BaseCard = __webpack_require__(50089);
// EXTERNAL MODULE: ./components/cards/transporter-card-top-section/TransporterCardTopSection.module.scss
var TransporterCardTopSection_module = __webpack_require__(73045);
var TransporterCardTopSection_module_default = /*#__PURE__*/__webpack_require__.n(TransporterCardTopSection_module);
// EXTERNAL MODULE: ../core/dist/icons/up_verified_profile.svg
var up_verified_profile = __webpack_require__(78888);
// EXTERNAL MODULE: ../core/dist/icons/GST_verified.svg
var GST_verified = __webpack_require__(66740);
// EXTERNAL MODULE: ../core/dist/icons/aadhar_verified_profile.svg
var aadhar_verified_profile = __webpack_require__(16600);
;// CONCATENATED MODULE: ../core/dist/icons/connections.svg
var connections_path;

function connections_extends() { connections_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return connections_extends.apply(this, arguments); }



function SvgConnections(props) {
  return /*#__PURE__*/react.createElement("svg", connections_extends({
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), connections_path || (connections_path = /*#__PURE__*/react.createElement("path", {
    d: "M5.197 8C3.332 8 0 9.07 0 11.2V14h10.393v-2.8c0-2.13-3.332-3.2-5.196-3.2zm0-1.6c1.538 0 2.789-1.435 2.789-3.2 0-1.765-1.251-3.2-2.79-3.2C3.66 0 2.409 1.435 2.409 3.2c0 1.765 1.25 3.2 2.789 3.2zm5.054 1.655c.924.768 1.562 1.792 1.562 3.145V14H15v-2.8c0-1.847-2.789-2.898-4.75-3.145zM9.629 6.4c1.538 0 2.789-1.435 2.789-3.2 0-1.765-1.251-3.2-2.789-3.2C9.2 0 8.8.119 8.434.32A5.49 5.49 0 019.23 3.2a5.49 5.49 0 01-.797 2.88c.366.201.765.32 1.195.32z",
    fill: "#666"
  })));
}

/* harmony default export */ var connections = (SvgConnections);
;// CONCATENATED MODULE: ../core/dist/icons/views.svg
var views_path;

function views_extends() { views_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return views_extends.apply(this, arguments); }



function SvgViews(props) {
  return /*#__PURE__*/react.createElement("svg", views_extends({
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), views_path || (views_path = /*#__PURE__*/react.createElement("path", {
    d: "M10.267 0C5.6 0 1.615 2.903 0 7c1.615 4.097 5.6 7 10.267 7 4.666 0 8.652-2.903 10.266-7-1.614-4.097-5.6-7-10.266-7zm0 11.667A4.668 4.668 0 015.6 7a4.668 4.668 0 014.667-4.667A4.668 4.668 0 0114.933 7a4.668 4.668 0 01-4.666 4.667zm0-7.467c-1.55 0-2.8 1.25-2.8 2.8 0 1.55 1.25 2.8 2.8 2.8 1.549 0 2.8-1.25 2.8-2.8 0-1.55-1.251-2.8-2.8-2.8z",
    fill: "#666"
  })));
}

/* harmony default export */ var views = (SvgViews);
;// CONCATENATED MODULE: ../core/dist/icons/years_lorry.svg
var years_lorry_path;

function years_lorry_extends() { years_lorry_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return years_lorry_extends.apply(this, arguments); }



function SvgYearsLorry(props) {
  return /*#__PURE__*/react.createElement("svg", years_lorry_extends({
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), years_lorry_path || (years_lorry_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 0a1 1 0 00-1 1v8.567A.5.5 0 000 10v1.25a.5.5 0 00.5.5h.561l-.404.501a.25.25 0 00.038.352l.194.157a.25.25 0 00.352-.038l.784-.972h.24a2 2 0 103.97 0H7.75v1a.5.5 0 00.5.5h7.917a.5.5 0 00.5-.5v-1h1.348a2 2 0 103.969 0h.766a.5.5 0 00.5-.5V6.59a.5.5 0 00-.03-.174l-.845-2.291-.747-1.815a.5.5 0 00-.463-.31H16.75a.5.5 0 00-.5.5v7h-1.333V1a1 1 0 00-1-1H1.25zm17 2.75a.5.5 0 00-.5.5V5.5a.5.5 0 00.5.5h3.31a.5.5 0 00.475-.656l-.348-1.06-.442-1.206a.5.5 0 00-.47-.328H18.25zM5.25 12a1 1 0 11-2 0 1 1 0 012 0zM20 13a1 1 0 100-2 1 1 0 000 2z",
    fill: "#666"
  })));
}

/* harmony default export */ var years_lorry = (SvgYearsLorry);
// EXTERNAL MODULE: ../core/dist/components/ellipsis-tooltip/EllipsisTooltip.js + 1 modules
var EllipsisTooltip = __webpack_require__(62945);
// EXTERNAL MODULE: ../core/dist/components/rating-stars/RatingStars.js + 4 modules
var RatingStars = __webpack_require__(78414);
// EXTERNAL MODULE: ../core/dist/components/grid/col/Col.js
var Col = __webpack_require__(12215);
// EXTERNAL MODULE: ../core/dist/components/grid/row/Row.js
var Row = __webpack_require__(11758);
// EXTERNAL MODULE: ../core/dist/components/dot-separated/DotSeparated.js + 1 modules
var DotSeparated = __webpack_require__(49143);
// EXTERNAL MODULE: ./components/utils/AppImg.tsx
var AppImg = __webpack_require__(17073);
// EXTERNAL MODULE: ./utils/getImageNameFromURL.ts
var getImageNameFromURL = __webpack_require__(72366);
// EXTERNAL MODULE: ../core-ui/dist/layout/Flex.js
var Flex = __webpack_require__(31013);
// EXTERNAL MODULE: ./components/admin/IfCanAccess/IfCanAccess.tsx
var IfCanAccess = __webpack_require__(6632);
// EXTERNAL MODULE: ./components/admin/badge/AgentBadge.tsx + 7 modules
var AgentBadge = __webpack_require__(65643);
;// CONCATENATED MODULE: ./components/cards/transporter-card-top-section/TransporterCardTopSection.tsx



// Styles

// Icons






// Components










var TransporterCardTopSection = function(param) {
    var ratings = param.ratings, isAadharVerified = param.isAadharVerified, isGstVerified = param.isGstVerified, companyName = param.companyName, jobTitle = param.jobTitle, companyLocation = param.companyLocation, totalConnections = param.totalConnections, totalViews = param.totalViews, companyRunningFrom = param.companyRunningFrom, logo = param.logo, agentDetails = param.agentDetails;
    var t = (0,esm/* useTranslation */.$G)([
        "common"
    ]).t;
    var profileVerification = isGstVerified && isAadharVerified ? /*#__PURE__*/ (0,jsx_runtime.jsx)(up_verified_profile/* default */.Z, {}) : isGstVerified && !isAadharVerified ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GST_verified/* default */.Z, {}) : !isGstVerified && isAadharVerified ? /*#__PURE__*/ (0,jsx_runtime.jsx)(aadhar_verified_profile/* default */.Z, {}) : "";
    var calculateNodes = function() {
        var arr = [];
        if (totalConnections) {
            arr.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (TransporterCardTopSection_module_default()).connections,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(connections, {}),
                    " ",
                    totalConnections,
                    " ",
                    t("common:connections")
                ]
            }));
        }
        if (totalViews) {
            arr.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (TransporterCardTopSection_module_default()).connections,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(views, {}),
                    " ",
                    totalViews,
                    " ",
                    t("common:views")
                ]
            }));
        }
        if (companyRunningFrom) {
            arr.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (TransporterCardTopSection_module_default()).connections,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(years_lorry, {}),
                    " ",
                    companyRunningFrom,
                    "+ ",
                    t("common:years")
                ]
            }));
        }
        return arr;
    };
    var nodes = calculateNodes();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (TransporterCardTopSection_module_default()).main,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                className: (TransporterCardTopSection_module_default()).profileDetailsRow,
                noGutters: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        className: (TransporterCardTopSection_module_default()).profileImageCol,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (TransporterCardTopSection_module_default()).image,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                                src: (0,getImageNameFromURL/* getImageNameFromURL */.O)(logo) || "default.png",
                                alt: "",
                                width: "75px",
                                height: "75px"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                        className: (TransporterCardTopSection_module_default()).profileTextCol,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                className: (TransporterCardTopSection_module_default()).name,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EllipsisTooltip/* default */.Z, {
                                        textValue: companyName || "",
                                        greaterThanValue: 22,
                                        mainClass: (TransporterCardTopSection_module_default()).nameEllipsis
                                    }),
                                    profileVerification
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (TransporterCardTopSection_module_default()).jobTitle,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                    noGutters: true,
                                    className: (TransporterCardTopSection_module_default()).alignCenter,
                                    children: [
                                        (ratings || 0) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                            className: (TransporterCardTopSection_module_default()).ratingsCol,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingStars/* default */.Z, {
                                                    className: (TransporterCardTopSection_module_default()).starIcons,
                                                    rating: ratings || 0
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: ratings.toFixed(1)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
                                                gap: 5,
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EllipsisTooltip/* default */.Z, {
                                                        textValue: jobTitle || "",
                                                        greaterThanValue: 25,
                                                        mainClass: (TransporterCardTopSection_module_default()).jobTitleEllipsis
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IfCanAccess/* default */.Z, {
                                                        action: "",
                                                        allowCsUser: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AgentBadge/* default */.Z, {
                                                            type: "tso",
                                                            data: agentDetails
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (TransporterCardTopSection_module_default()).location
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (TransporterCardTopSection_module_default()).location,
                                children: companyLocation
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                className: (TransporterCardTopSection_module_default()).profileDetailsRow,
                noGutters: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((TransporterCardTopSection_module_default()).profileTextCol, (TransporterCardTopSection_module_default()).oneLineInfo),
                    children: nodes.length && nodes.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DotSeparated/* default */.Z, {
                        dotStyleClassName: (TransporterCardTopSection_module_default()).dot,
                        nodes: nodes
                    }) : // This was done to remove the imbalance when there is no info to show
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            marginTop: "14px"
                        }
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var transporter_card_top_section_TransporterCardTopSection = (TransporterCardTopSection);

;// CONCATENATED MODULE: ./components/cards/transporter-card-bottom-section/TransporterCardBottomSection.tsx
/** Profile CTA removed from transport directory. Contact CTA is currently unused. */ var TransporterCardBottomSection = function(_props) {
    return null;
};
/* harmony default export */ var transporter_card_bottom_section_TransporterCardBottomSection = (TransporterCardBottomSection);

;// CONCATENATED MODULE: ./components/cards/transporter-card/TransporterCard.tsx


// Styles

// Components



var TransporterCard = function(param) {
    var companyName = param.companyName, jobTitle = param.jobTitle, totalConnections = param.totalConnections, totalViews = param.totalViews, companyRunningFrom = param.companyRunningFrom, companyLocation = param.companyLocation, isGstVerified = param.isGstVerified, isAadharVerified = param.isAadharVerified, companyId = param.companyId, logo = param.logo, ratings = param.ratings, onGetContactDetailsCtaClick = param.onGetContactDetailsCtaClick, onViewProfileCtaClick = param.onViewProfileCtaClick, companyPhoneNumber = param.companyPhoneNumber, agentDetails = param.agentDetails;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (TransporterCard_module_default()).cardWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseCard/* default */.Z, {
            topSection: /*#__PURE__*/ (0,jsx_runtime.jsx)(transporter_card_top_section_TransporterCardTopSection, {
                companyName: companyName,
                logo: logo,
                jobTitle: jobTitle,
                totalConnections: totalConnections,
                totalViews: totalViews,
                companyRunningFrom: companyRunningFrom,
                companyLocation: companyLocation,
                isGstVerified: isGstVerified,
                isAadharVerified: isAadharVerified,
                companyId: companyId,
                ratings: ratings,
                agentDetails: agentDetails
            }),
            bottomSection: /*#__PURE__*/ (0,jsx_runtime.jsx)(transporter_card_bottom_section_TransporterCardBottomSection, {
                companyId: companyId,
                companyName: companyName,
                companyLocation: companyLocation,
                onGetContactDetailsCtaClick: onGetContactDetailsCtaClick,
                onViewProfileCtaClick: onViewProfileCtaClick,
                companyPhoneNumber: companyPhoneNumber
            })
        })
    });
};
/* harmony default export */ var transporter_card_TransporterCard = (TransporterCard);

// EXTERNAL MODULE: ./components/transporter/search/searchResultsContainer.module.scss
var searchResultsContainer_module = __webpack_require__(3787);
var searchResultsContainer_module_default = /*#__PURE__*/__webpack_require__.n(searchResultsContainer_module);
;// CONCATENATED MODULE: ./components/transporter/search/SearchResultsContainer.tsx








var SearchResults = function(param) {
    var data = param.data, className = param.className, id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* default */.Z, {
        className: classnames_default()(className, (searchResultsContainer_module_default()).cardWrapperContainer),
        id: id,
        children: (data === null || data === void 0 ? void 0 : data.length) && (data === null || data === void 0 ? void 0 : data.map(function(d, i) {
            return (d === null || d === void 0 ? void 0 : d.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((searchResultsContainer_module_default()).cardWrapper),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transporter_card_TransporterCard, {
                    companyName: d.name,
                    logo: d.logo,
                    jobTitle: d.service_type,
                    totalConnections: d.total_connections,
                    totalViews: d.total_views,
                    companyRunningFrom: d.years_in_business,
                    companyLocation: "".concat(d.city_name, ", ").concat(d.state_name),
                    isAadharVerified: d.is_aadhaar_verified,
                    isGstVerified: d.is_gst_verified,
                    companyId: d.company_identity,
                    ratings: d.rating,
                    companyPhoneNumber: d.phone_number,
                    onGetContactDetailsCtaClick: function() {
                        (0,user_analytics_service/* ga4sendEvent */.zs)(event_names/* GA4EventNames.Homepage_meet_india_transporter_change_city_after_selection */.wQ.Homepage_meet_india_transporter_change_city_after_selection, {
                            value: event_names/* GA4HomePageMeetTransportServiceProvidersEventValues.get_contact_details */.N9.get_contact_details
                        });
                    }
                }, i)
            }, i);
        }))
    });
};
/* harmony default export */ var SearchResultsContainer = (/*#__PURE__*/react.memo(SearchResults));

// EXTERNAL MODULE: ../core/dist/components/app-anchor/A.js
var A = __webpack_require__(70561);
// EXTERNAL MODULE: ../core/dist/icons/arrow-right-white.svg
var arrow_right_white = __webpack_require__(89905);
// EXTERNAL MODULE: ./components/common/cta-banner/CTABanner.module.scss
var CTABanner_module = __webpack_require__(67507);
var CTABanner_module_default = /*#__PURE__*/__webpack_require__.n(CTABanner_module);
;// CONCATENATED MODULE: ./components/common/cta-banner/CTABanner.tsx


// import FadeIn from "react-lazyload-fadein";







var CTABanner = function(param) {
    var href = param.href, title = param.title;
    var isMobile = (0,react.useContext)(app_context/* AppContext */.Il).isMobile;
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "transporters"
    ]).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (CTABanner_module_default()).ctaBannerWrap,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                href: href,
                title: title,
                openInNewTab: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (CTABanner_module_default()).ctaBanner,
                    style: {
                        position: "relative",
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                            id: "ctaImage",
                            src: "bottom_banner_background_web.png",
                            // srcSet={`${ctaBgrLarge} 992w , ${ctaBgSmall} 768w`}
                            className: (CTABanner_module_default()).CtaImage,
                            alt: t("transporters:bottom_cover.heading"),
                            width: "1440",
                            height: "349"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container",
                            style: {
                                position: "absolute",
                                bottom: isMobile ? "-5px" : "-12px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (CTABanner_module_default()).ctaRow,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (CTABanner_module_default()).ctaCol,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (CTABanner_module_default()).text,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: t("transporters:bottom_cover.title")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: t("transporters:bottom_cover.sub_title")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppBtn/* default */.Z, {
                                                    className: (CTABanner_module_default()).ctaButton,
                                                    children: [
                                                        t("transporters:bottom_cover.button_cta"),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right_white/* default */.Z, {})
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (CTABanner_module_default()).ctaCol,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (CTABanner_module_default()).imgBox,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                                                src: "bottom_banner_foreground_website.png",
                                                // srcSet={`${ctaFgLarge} 992w, ${ctaFgSmall} 768w`}
                                                alt: t("transporters:bottom_cover.heading"),
                                                height: "546",
                                                width: "458"
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var cta_banner_CTABanner = (CTABanner);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ../core/dist/methods/getPageLoadSourceUTMParam.js
var getPageLoadSourceUTMParam = __webpack_require__(96762);
// EXTERNAL MODULE: ./constants/breadcrumbs-constants.ts
var breadcrumbs_constants = __webpack_require__(96080);
// EXTERNAL MODULE: ../core/dist/_services/const.js
var _services_const = __webpack_require__(41634);
// EXTERNAL MODULE: ../core/dist/hooks/useVahakHttpClient.js
var useVahakHttpClient = __webpack_require__(36153);
// EXTERNAL MODULE: ../core/dist/hooks/useVahakQueryClient.js
var useVahakQueryClient = __webpack_require__(37528);
// EXTERNAL MODULE: ../core/dist/_services/hooks/queryNames.js
var queryNames = __webpack_require__(49352);
// EXTERNAL MODULE: ../core/dist/_services/utils/getAuthHeader.js
var utils_getAuthHeader = __webpack_require__(21928);
;// CONCATENATED MODULE: ./services/useTransporterService.ts









function transporterSearch(_) {
    return _transporterSearch.apply(this, arguments);
}
function _transporterSearch() {
    _transporterSearch = _async_to_generator(regeneratorRuntime.mark(function _callee(param) {
        var cityId, routeStateIds, service_type, name, _page, page, transporterId, sourcePlaceId, response, dataFromServer;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    cityId = param.cityId, routeStateIds = param.routeStateIds, service_type = param.service_type, name = param.name, _page = param.page, page = _page === void 0 ? 1 : _page, transporterId = param.transporterId, sourcePlaceId = param.sourcePlaceId;
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return fetch("".concat(API.TRANSPORTER_SEARCH), {
                        method: "POST",
                        headers: _object_spread_props(_object_spread({}, getAuthHeader()), {
                            origin: "http://localhost:3000",
                            referer: "http://localhost:3000/"
                        }),
                        body: JSON.stringify(_object_spread({
                            page_number: page,
                            source_place_id: sourcePlaceId ? [
                                sourcePlaceId
                            ] : undefined,
                            states: routeStateIds,
                            company_name: name,
                            service_type: service_type
                        }, transporterId && {
                            company_id: [
                                transporterId
                            ]
                        }))
                    });
                case 4:
                    response = _ctx.sent;
                    _ctx.next = 7;
                    return response.json();
                case 7:
                    dataFromServer = _ctx.sent;
                    return _ctx.abrupt("return", dataFromServer.data);
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](1);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", undefined);
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                11
            ]
        ]);
    }));
    return _transporterSearch.apply(this, arguments);
}
function getTransporterProfileReviews(_) {
    return _getTransporterProfileReviews.apply(this, arguments);
}
function _getTransporterProfileReviews() {
    _getTransporterProfileReviews = _async_to_generator(regeneratorRuntime.mark(function _callee(param) {
        var id, limit, response, dataFromServer;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    id = param.id, limit = param.limit;
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return fetch("".concat(API.TRANSPORTER_REVIEWS, "?company_id=").concat(id).concat(limit ? "&l=" + limit : ""), {
                        method: "GET",
                        headers: _object_spread_props(_object_spread({
                            Accept: "application/json",
                            "Content-Type": "application/json"
                        }, getAuthHeader()), {
                            origin: "http://localhost:3000",
                            referer: "http://localhost:3000/"
                        })
                    });
                case 4:
                    response = _ctx.sent;
                    _ctx.next = 7;
                    return response.json();
                case 7:
                    dataFromServer = _ctx.sent;
                    return _ctx.abrupt("return", dataFromServer.data);
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](1);
                    return _ctx.abrupt("return", undefined);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                11
            ]
        ]);
    }));
    return _getTransporterProfileReviews.apply(this, arguments);
}
function getTransporterProfileFaqs(id) {
    return _getTransporterProfileFaqs.apply(this, arguments);
}
function _getTransporterProfileFaqs() {
    _getTransporterProfileFaqs = _async_to_generator(regeneratorRuntime.mark(function _callee(id) {
        var response, dataFromServer;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return fetch("".concat(API.TRANSPORTER_FAQ), {
                        method: "POST",
                        headers: _object_spread_props(_object_spread({}, getAuthHeader()), {
                            origin: "http://localhost:3000",
                            referer: "http://localhost:3000/"
                        }),
                        body: JSON.stringify({
                            company_id: [
                                id
                            ]
                        })
                    });
                case 3:
                    response = _ctx.sent;
                    _ctx.next = 6;
                    return response.json();
                case 6:
                    dataFromServer = _ctx.sent;
                    return _ctx.abrupt("return", dataFromServer.data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", undefined);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }));
    return _getTransporterProfileFaqs.apply(this, arguments);
}
function useTransporterSearch() {
    var POST = (0,useVahakHttpClient/* default */.Z)().POST;
    var search = function(param) {
        var cityId = param.cityId, routeStateIds = param.routeStateIds, service_type = param.service_type, name = param.name, _page = param.page, page = _page === void 0 ? 1 : _page, sourcePlaceId = param.sourcePlaceId;
        var payload = {
            page_number: page,
            city_id: cityId ? [
                cityId
            ] : undefined,
            source_place_id: sourcePlaceId ? [
                sourcePlaceId
            ] : undefined,
            state_id: routeStateIds,
            company_name: name,
            service_type: service_type
        };
        return POST("".concat(_services_const/* default.TRANSPORTER_SEARCH */.Z.TRANSPORTER_SEARCH), payload).then(function(data) {
            return data.data;
        });
    };
    return (0,useVahakQueryClient/* useVahakMutationQuery */.M8)(queryNames/* QueryNames.transporters.getTransporterList */._.transporters.getTransporterList, search);
}

// EXTERNAL MODULE: ./components/common/page-meta-tags/PageMetaTags.tsx
var PageMetaTags = __webpack_require__(96696);
// EXTERNAL MODULE: ../core-ui/dist/components/ShowMoreText/index.js + 1 modules
var ShowMoreText = __webpack_require__(52585);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/index.js
var Typography = __webpack_require__(71960);
// EXTERNAL MODULE: ./components/transporter/helper/CityDescription.module.scss
var CityDescription_module = __webpack_require__(91932);
var CityDescription_module_default = /*#__PURE__*/__webpack_require__.n(CityDescription_module);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
;// CONCATENATED MODULE: ./components/transporter/helper/getFaqList.ts

var getFaqListByCity = function(ct) {
    var city = ct;
    var cityUpperCase = city.toLocaleUpperCase();
    var titleH1Desc = "";
    var titleH2 = "How is Vahak different from other transport services in ".concat(city, "?");
    var titleH2DescList = [
        {
            id: 1,
            content: "In a commercial city like ".concat(city, ", the demand for dependable transport services is ever-growing. Vahak, as a leading provider among transporters in ").concat(city, ", offers a comprehensive suite of transportation solutions tailored to the city's needs. We provide specialised load and lorry booking services designed to cater to different cargo sizes and types, ensuring flexibility and convenience for our clients.")
        },
        {
            id: 2,
            content: "The difference lies in how Vahak integrates technology with human-centric service. The platform is designed to simplify the complexities of transport services in ".concat(city, ", making it easier for businesses and individuals to find the right logistics solutions. By prioritising user experience and satisfaction, Vahak offers a seamless interface for users to connect with transporters in ").concat(city, ", ensuring that their specific needs are met efficiently and effectively.")
        },
        {
            id: 3,
            content: "Discover the Vahak difference and join a network where reliable transport solutions meet innovative service. Join Vahak today."
        }
    ];
    var dynamicFaqDesc1 = "";
    switch(cityUpperCase){
        case "CHENNAI":
            {
                titleH1Desc = "Chennai, a bustling hub in Southern India, is swiftly climbing the ranks as one of the nation's fastest-growing cities. As the capital of Tamil Nadu, it's a melting pot of culture, industry, and education, attracting people from various walks of life. Vahak, a prime choice for transporters in Chennai, offers reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and complete transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Chennai's transportation landscape. ";
                dynamicFaqDesc1 = "Major transportation routes in Chennai include the Chennai Bypass, connecting the northern and southern parts of the city, and the Grand Southern Trunk Road, serving as a vital link to industrial areas and the Chennai airport.";
                break;
            }
        case "BANGALORE":
        case "BENGALURU":
            {
                titleH1Desc = "Bangalore is one of India's fastest-growing cities, and efficient transportation infrastructure is crucial to sustain this growth. Vahak, a key player in the transport services in Bangalore, ensures a seamless flow of goods and services. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Bangalore's transportation landscape. ";
                dynamicFaqDesc1 = "Major transportation routes in Bangalore include the Outer Ring Road, connecting major highways around the city, and the Hosur Road, linking central Bangalore to the southern suburbs and the IT hub of Electronic City.";
                break;
            }
        case "AHMEDABAD":
            {
                titleH1Desc = "Ahmedabad, a flourishing city in the western state of Gujarat, India, is undergoing a remarkable transformation. As one of the fastest-growing urban areas in the nation, Ahmedabad faces the crucial task of developing an efficient transportation infrastructure to sustain its rapid expansion. Vahak, a prime choice for transporters in Ahmedabad, offering reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Ahmedabad's transportation landscape. ";
                dynamicFaqDesc1 = "Major transportation routes in Ahmedabad include the Sardar Patel Ring Road, connecting various city sectors, and the Ahmedabad-Vadodara Expressway, facilitating access to major industrial and commercial zones.";
                break;
            }
        case "MUMBAI":
            {
                titleH1Desc = "Mumbai, the bustling metropolis and financial hub of India, is undergoing a remarkable transformation. As a rapidly growing city, it faces the vital need for efficient transportation infrastructure to sustain and support its continuous expansion. Vahak, a prime choice for transporters in Mumbai, offering reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Mumbai's transportation landscape. ";
                dynamicFaqDesc1 = "Key transportation routes in Mumbai include the Western Express Highway, linking the city to its suburbs and beyond, and the Eastern Express Highway, providing vital connectivity to various parts of Mumbai.";
                break;
            }
        case "HYDERABAD":
            {
                titleH1Desc = "Hyderabad, a major city in southern India, is undergoing rapid growth and transformation. To support this expansion, a strong and efficient transportation infrastructure is vital. Vahak, a prime choice for transporters in Hyderabad, offering reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and complete transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Hyderabad's transportation landscape. ";
                dynamicFaqDesc1 = "Key transportation routes in Hyderabad include the Outer Ring Road, which is essential for connecting various parts of the city, and the Hyderabad-Bangalore Highway, crucial for intercity travel and cargo movement.";
                break;
            }
        case "INDORE":
            {
                titleH1Desc = "Indore, a flourishing city in the heart of India, is evolving rapidly. To keep up with this growth, a strong transportation infrastructure is essential. Vahak, a prime choice for transporters in Indore, offering reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Indore's transportation landscape. ";
                dynamicFaqDesc1 = "Major transportation routes in Indore include the AB Road (Agra-Bombay Road), which is a crucial artery connecting the city to major destinations, and the Ring Road, encircling Indore and providing efficient connectivity across the city.";
                break;
            }
        case "PUNE":
            {
                titleH1Desc = "Pune, a city celebrated for its unique blend of rich cultural heritage and modern innovation, is rapidly emerging as a key player in India's growth story. Amidst this progress, the importance of an efficient transportation infrastructure cannot be overstated. Vahak, a prime choice for transporters in Pune, offering reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Pune's transportation landsc ";
                dynamicFaqDesc1 = "Pune's transport network includes major roads like the Pune-Bengaluru Expressway and Pune-Nashik Motorway, connecting to big cities. The Pune Railway Station is a main train hub. There are also many PMPML buses and a new Pune Metro Rail coming .";
                break;
            }
        case "DELHI":
            {
                titleH1Desc = "Delhi, India's capital, stands out as a city of historical significance and political prominence. As the city experiences exceptional growth, the development of an efficient transportation infrastructure becomes crucial to sustain its expansion. Vahak, a prime choice for transporters in Delhi, offering reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Delhi's transportation landsc ";
                dynamicFaqDesc1 = "Delhi's transport network features key roads like the Delhi-Gurgaon Expressway and the Outer Ring Road, linking to important areas. Key train stations like New Delhi Railway Station provide extensive rail connections. .";
                break;
            }
        case "JAIPUR":
            {
                titleH1Desc = "Jaipur, renowned for its rich cultural heritage and architectural marvels, is rapidly evolving into one of India's most dynamic cities. As it grows, developing a robust transportation infrastructure becomes essential to support its progress. Vahak, a prime choice for transporters in Jaipur, offering reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Jaipur's transportation landscape. ";
                dynamicFaqDesc1 = "\n            Jaipur's transport system includes major routes like the Jaipur-Ajmer Expressway and the Jaipur-Delhi National Highway, offering strong connections to other cities. The Jaipur Railway Station is a primary rail hub. ";
                break;
            }
        case "RAJKOT":
            {
                titleH1Desc = "Rajkot, a rapidly growing city in the vibrant state of Gujarat, India, is undergoing significant changes. To support this growth, the development of an efficient transportation infrastructure is essential. Vahak, a prime choice for transporters in Rajkot, offering reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Rajkot's transportation landscape. ";
                dynamicFaqDesc1 = "Rajkot, a rapidly growing city in the vibrant state of Gujarat, India, is undergoing significant changes. To support this growth, the development of an efficient transportation infrastructure is essential. Vahak, a prime choice for transporters in Rajkot, offering reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Rajkot's transportation landscape. ";
                break;
            }
        case "AGRA":
            {
                titleH1Desc = "Agra, known worldwide for the iconic Taj Mahal, is more than just a tourist destination; it's a rapidly growing urban centre in India. The city's expansion underscores the need for an efficient transportation infrastructure to support its growth. Vahak, a prime choice for transporter in Agra, offers reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Agra's transportation landscape. ";
                dynamicFaqDesc1 = "Agra's transport infrastructure features prominent roads like the Agra-Lucknow Expressway and the Agra-Delhi National Highway, connecting it to major cities. The Agra Cantt Railway Station is a key junction for rail travel.   ";
                break;
            }
        case "BHOPAL":
            {
                titleH1Desc = "Bhopal, the capital city of Madhya Pradesh, is evolving rapidly as an urban hub in central India. The city's growth highlights the pressing need for an efficient transportation infrastructure to support its development: Vahak, a prime choice for transporter in Bhopal, offering reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Bhopal's transportation landscape. ";
                dynamicFaqDesc1 = "Bhopal's transport network is anchored by important roads like the Bhopal-Indore Highway and the Bhopal-Nagpur Highway, linking it to various regions. The Bhopal Junction Railway Station serves as a central point for train connections.";
                break;
            }
        case "CHANDIGARH":
            {
                titleH1Desc = "Chandigarh, known for its distinctive urban planning and architecture, is emerging as a rapidly growing city in North India. To accommodate this growth, developing an efficient transportation infrastructure is becoming increasingly crucial. Vahak, a prime choice for transporter in Chandigarh, offers reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Chandigarh's transportation landscape. ";
                dynamicFaqDesc1 = "Chandigarh's transportation system is served by key routes like the Chandigarh-Delhi Highway and the Chandigarh-Manali Expressway, ensuring connectivity to major areas. The Chandigarh Railway Station is a vital link for train travel.";
                break;
            }
        case "COIMBATORE":
            {
                titleH1Desc = "Coimbatore, often referred to as the Manchester of South India, is experiencing a surge in growth, making the need for an efficient transportation infrastructure increasingly important. Vahak, a prime choice for transporter in Coimbatore, offering reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Coimbatore's transportation landscape. ";
                dynamicFaqDesc1 = "Coimbatore's transport network includes crucial roads like the Coimbatore-Salem Highway and the Coimbatore-Ooty Highway, providing connections to various places. The Coimbatore Junction Railway Station plays a key role in rail connectivity. ";
                break;
            }
        case "FARIDABAD":
            {
                //
                titleH1Desc = "Vahak, a prime choice for transporter in Faridabad, offers reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Faridabad's transportation landscape.";
                dynamicFaqDesc1 = "Faridabad's transportation framework is supported by significant roads, such as the Delhi-Agra National Highway and the Faridabad-Gurgaon Road, linking it to key locations. The Faridabad Railway Station is an important rail link for the region.";
                break;
            }
        case "GANDHIDAM":
            {
                titleH1Desc = "Gandhidham, a key city in the Kutch district of Gujarat, India, is experiencing significant growth, underscoring the need for an efficient transportation infrastructure to support its development. Vahak, a prime choice for transporter in Gandhidam, offers reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Gandhidam's transportation landscape. ";
                dynamicFaqDesc1 = "Gandhidham's transport network is characterised by essential routes like the Gandhidham-Bhuj Highway and the Kandla Port Road, providing vital links to major trade and industrial centres. The Gandhidham Railway Station is a key junction for regional rail connectivity.";
                break;
            }
        case "GANDHINAGAR":
            {
                titleH1Desc = "Gandhinagar, the capital city of Gujarat, is on a trajectory of rapid growth, highlighting the necessity for an efficient transportation infrastructure to sustain its development. Vahak, a prime choice for transporter in Gandhinagar, offers reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Gandhinagar's transportation landscape. ";
                dynamicFaqDesc1 = "Gandhinagar's transport system is facilitated by major routes such as the Ahmedabad-Gandhinagar Highway and the Gandhinagar-Vadodara Highway, offering easy access to surrounding cities. The Gandhinagar Capital Railway Station is a crucial rail link.";
                break;
            }
        case "GHAZIABAD":
            {
                titleH1Desc = "Ghaziabad, a rapidly growing city in the National Capital Region (NCR) of India, is witnessing a significant transformation, emphasizing the importance of an efficient transportation infrastructure to sustain its development. Vahak, a prime choice for transporter in Ghaziabad, offers reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Ghaziabad's transportation landscape. ";
                dynamicFaqDesc1 = "Ghaziabad's transportation infrastructure includes key routes like the Delhi-Meerut Expressway and the Ghaziabad-Noida Direct Flyway, connecting it efficiently to neighbouring cities. The Ghaziabad Railway Station serves as a central hub for train travel in the regio.";
                break;
            }
        case "KANPUR":
            {
                titleH1Desc = "Kanpur, an important industrial city in Uttar Pradesh, India, is experiencing rapid growth, underscoring the need for an efficient transportation infrastructure to support its expansion. Vahak, a prime choice for transporter in Kanpur, offers reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Kanpur's transportation landscap. ";
                dynamicFaqDesc1 = "Kanpur's transport network features significant roads, such as the Kanpur-Lucknow Expressway and the Kanpur-Allahabad Highway, ensuring smooth connectivity to other major cities. The Kanpur Central Railway Station is a key junction for rail travel. ";
                break;
            }
        case "KOLKATA":
            {
                titleH1Desc = "Kolkata, one of India's largest cities and a historical hub, is undergoing significant urban growth, highlighting the importance of an efficient transportation infrastructure to support its expansion. Vahak, a prime choice for transporter in Kolkata, offers reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Kolkata's transportation landscape. ";
                dynamicFaqDesc1 = "Kolkata's transport network is anchored by key roads like the Kolkata-Delhi Highway and the Kolkata-Chennai Highway, linking it to major urban centres. The Howrah and Sealdah railway stations are vital for rail connectivity.";
                break;
            }
        case "LUCKNOW":
            {
                titleH1Desc = "Lucknow, the capital city of Uttar Pradesh, is witnessing a rapid pace of urbanization, making the development of an efficient transportation infrastructure critical for its growth. Vahak, a prime choice for transporter in Lucknow, offers reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Lucknow's transportation landscape. ";
                dynamicFaqDesc1 = "Lucknow's transportation infrastructure is highlighted by major roads like the Lucknow-Agra Expressway and the Lucknow-Kanpur Highway, connecting it to various regions. The Lucknow Junction Railway Station is a central hub for train travel.";
                break;
            }
        case "NOIDA":
            {
                titleH1Desc = "Noida, a rapidly developing city in the National Capital Region (NCR) of India, is experiencing significant urban growth, emphasizing the need for an efficient transportation infrastructure to support its expansion. Vahak, a prime choice for transporter in Noida, offers reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Noida's transportation landscape. ";
                dynamicFaqDesc1 = "Noida's transportation network is marked by significant roads, such as the Noida-Greater Expressway and the Yamuna Expressway, providing efficient connectivity to various regions. ";
                break;
            }
        case "PATNA":
            {
                titleH1Desc = "Patna, the capital city of Bihar, is on a trajectory of rapid urbanization, highlighting the need for an efficient transportation infrastructure to keep up with its growth. Vahak, a prime choice for transporter in Patna, offers reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Patna's transportation landscape. ";
                dynamicFaqDesc1 = "Patna's transportation infrastructure includes major roadways like the Patna-Bakhtiyarpur Toll Road and the NH-30, connecting the city to important regions. The Patna Junction Railway Station is a key hub for rail connectivity, linking Patna to various parts of India.";
                break;
            }
        case "VIZAG":
            {
                titleH1Desc = "Vizag, also known as Visakhapatnam, is emerging as a key urban center in Andhra Pradesh, India, with its rapid growth underscoring the need for an efficient transportation infrastructure. Vahak, a prime choice for transporter in Vizag, offers reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Vizag's transportation landscape. ";
                dynamicFaqDesc1 = "\n           Vizag boasts a well-developed transportation network, with key roads such as the Vizag-Vijayawada Highway and the Coastal Andhra Expressway enhancing connectivity to other regions. The Visakhapatnam Railway Station is a prominent rail link, providing extensive connections across India.  ";
                break;
            }
        case "VISAKHAPATNAM":
            {
                titleH1Desc = "Vishakapatnam, popularly known as Vizag, is rapidly growing, underlining the importance of an efficient transportation infrastructure to sustain its development. Vahak, a prime choice for transporter in Visakhapatnam, offers reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Visakhapatnam's transportation landscape. ";
                dynamicFaqDesc1 = "Visakhapatnam boasts a well-developed transportation network, with key roads such as the Visakhapatnam-Vijayawada Highway and the Coastal Andhra Expressway enhancing connectivity to other regions. The Visakhapatnam Railway Station is a primary rail link, providing extensive connections across India. ";
                break;
            }
        case "VARANASI":
            {
                titleH1Desc = "Varanasi, one of India's oldest and most culturally significant cities, is experiencing a phase of rapid urbanization, emphasizing the need for an efficient transportation infrastructure to accommodate its growth.Vahak, a prime choice for transporter in Varanasi, offers reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Varanasi's transportation landscape. ";
                dynamicFaqDesc1 = "In Varanasi, major road transportation routes include the Varanasi-Ghazipur Highway, which connects the city to Ghazipur and other eastern parts of Uttar Pradesh, and the Varanasi-Shaktinagar Route, facilitating travel towards the northern regions. Additionally, the city's inner road network, comprising the Ring Road and the Godowlia to Cantt Road, plays a crucial role in local commuting, linking key areas within Varanasi and easing traffic flow across the city. ";
                break;
            }
        case "VADODARA":
            {
                titleH1Desc = "Vadodara, a prominent city in Gujarat, is undergoing significant urban growth, highlighting the importance of an efficient transportation infrastructure to support its expansion. Vahak, a prime choice for transporter in Vadodara, offers reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Vadodara's transportation landscape. ";
                dynamicFaqDesc1 = "In Vadodara, major road transportation centres around key routes like the Vadodara-Ahmedabad Expressway provide swift connectivity to Ahmedabad, and the Vadodara-Mumbai National Highway links the city to Mumbai. The city's internal transport infrastructure is bolstered by the Ring Road and the Alkapuri Road, facilitating smooth local commuting and connecting various parts of Vadodara.  ";
                break;
            }
        case "UDAIPUR":
            {
                titleH1Desc = "Udaipur, often referred to as the 'City of Lakes' in Rajasthan, is experiencing notable urban growth, underscoring the need for an efficient transportation infrastructure to sustain its development. Vahak, a prime choice for transporter in Udaipur, offers reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Udaipur's transportation landscape. ";
                dynamicFaqDesc1 = "Udaipur's transportation network is characterised by essential roadways like the Udaipur-Ahmedabad Highway, connecting it to major cities like Ahmedabad and the Udaipur-Nathdwara Highway, facilitating travel to religious and tourist destinations. Additionally, internal routes such as the Udaipur Bypass and the city's main arterial road, University Road, ensure smooth local commuting and connect various parts of Udaipur.  ";
                break;
            }
        case "THANE":
            {
                titleH1Desc = "Thane, an emerging metropolitan city in the Mumbai metropolitan region of Maharashtra, is experiencing rapid urbanisation, highlighting the need for an efficient transportation infrastructure to support its growth. Vahak, a prime choice for transporter in Thane, offers reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Thane's transportation landscape. ";
                dynamicFaqDesc1 = "Thane's major transportation routes include the Eastern Express Highway and the Thane-Belapur Road, connecting it to Mumbai and Navi Mumbai. The Ghodbunder Road is also key, linking various parts of Thane and providing access to the Western Express Highway.  ";
                break;
            }
        case "SURAT":
            {
                titleH1Desc = "Surat, a rapidly growing city in the state of Gujarat, India, is experiencing significant urban expansion, making the development of an efficient transportation infrastructure essential for its growth. Vahak, a prime choice for transporter in Surat, offers reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and Surat's transportation landscape. ";
                dynamicFaqDesc1 = "In Surat, key transportation routes include the Surat-Dumas Road, which connects the city centre to coastal areas, and the Surat-Olpad Road, facilitating access to southern regions. The city is also served by the Surat-Bardoli Road, linking it to Bardoli and other eastern localities. These significant roads are crucial in Surat's connectivity and daily commute.  ";
                break;
            }
        default:
            {
                titleH1Desc = "Vahak, a prime choice for transporter in ".concat(city, ", offers reliable and comprehensive transport solutions. Our platform is the go-to choice for shippers, fleet owners, and transport contractors seeking reliable and comprehensive transport solutions. Committed to reliability and innovation, we enhance connectivity, contributing to the city's economic vitality with our wide range of services like load booking, lorry booking, part-load booking, part-lorry booking and many more. Join us & transform your business and ").concat(city, "'s transportation landscape.");
            }
    }
    var faqList = [
        {
            question: "What types of goods can be transported in ".concat(city, "?"),
            answer: "You can transport any type of goods, including commercial and industrial items, with Vahak's transport services in ".concat(city, " and beyond.")
        },
        {
            question: "How can I track my shipment in ".concat(city, "?"),
            answer: "Once you book your shipment with our transporters in ".concat(city, ", you can easily track its status in your dashboard once it's en route, ensuring you're constantly updated.")
        }
    ].concat((0,_to_consumable_array/* default */.Z)(!!dynamicFaqDesc1 ? [
        {
            question: "What are the major transportation routes in ".concat(city, "?"),
            answer: dynamicFaqDesc1
        }
    ] : []), [
        {
            question: "How can I book a transport service in ".concat(city, "?"),
            answer: "To book transport services in ".concat(city, " with Vahak:"),
            descList: [
                "Visit <a href='https://www.vahak.in/'>www.vahak.in.</a>",
                "Create an account or log in by providing your ID details for verification.",
                "Click on 'Browse Transporters Near Me' to view a list of local transporters, including their names, email addresses, and phone numbers.",
                "You can either view their profiles for more details or directly contact them to arrange your transport service."
            ]
        }
    ]);
    return {
        titleH1Desc: titleH1Desc,
        titleH2: titleH2,
        titleH2DescList: titleH2DescList,
        faqList: faqList
    };
};

// EXTERNAL MODULE: ../../node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(14304);
;// CONCATENATED MODULE: ./components/transporter/helper/CityDescription.tsx






var CityDescription = function(param) {
    var city = param.city;
    var ref = getFaqListByCity(city), faqList = ref.faqList, titleH1Desc = ref.titleH1Desc, titleH2 = ref.titleH2, titleH2DescList = ref.titleH2DescList;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (CityDescription_module_default()).main,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (CityDescription_module_default()).desc,
                        children: titleH2
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CityDescription_module_default()).descList,
                        children: titleH2DescList === null || titleH2DescList === void 0 ? void 0 : titleH2DescList.map(function(desc, ix) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: desc.content
                            }, ix);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CityDescription_module_default()).faq,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (CityDescription_module_default()).faqTitle,
                        children: "FAQ"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                        children: faqList === null || faqList === void 0 ? void 0 : faqList.map(function(param, ix) {
                            var question = param.question, answer = param.answer, descList = param.descList;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            as: "h3",
                                            children: question
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: answer
                                        }),
                                        !!descList && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: descList === null || descList === void 0 ? void 0 : descList.map(function(d) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: (0,browser.sanitize)(d)
                                                    }
                                                }, d);
                                            })
                                        })
                                    ]
                                })
                            }, ix);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var helper_CityDescription = (CityDescription);

// EXTERNAL MODULE: ../core/dist/hooks/useDebounce.js
var useDebounce = __webpack_require__(63478);
// EXTERNAL MODULE: ../core/dist/constants/index.js + 4 modules
var constants = __webpack_require__(94204);
// EXTERNAL MODULE: ../core-ui/dist/components/Button/index.js
var Button = __webpack_require__(32450);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ./components/marketplace/mandate-service-type/MandateServiceType.tsx
var MandateServiceType = __webpack_require__(9740);
// EXTERNAL MODULE: ../core/dist/_services/index.js + 6 modules
var _services = __webpack_require__(96122);
;// CONCATENATED MODULE: ./components/transporter/search/Search.tsx


















// import "./Search.scss";












// import EventScriptOnLoad from "utils/EventScriptOnLoad";
















var BOT_USER_AGENT_PATTERN = /bot|crawler|spider|googlebot|bingbot|msnbot|yandexbot|baiduspider|slurp|duckduckbot/i;
var Search_Search = function(param) {
    var _searchResults = param.searchResults, searchResults = _searchResults === void 0 ? null : _searchResults;
    var ref;
    var t = (0,esm/* useTranslation */.$G)([
        "transporters"
    ]).t;
    var ref1 = (0,react.useContext)(app_context/* AppContext */.Il), currentLocation = ref1.currentLocation, isPhoneVerified = ref1.isPhoneVerified, companyId = ref1.companyId, serviceType = ref1.serviceType, updateEventCount = ref1.updateEventCount, eventCounts = ref1.eventCounts;
    var fetchOnClient = searchResults == null;
    var ref2 = (0,react.useState)(fetchOnClient), shouldExecuteApi = ref2[0], setShouldExecuteApi = ref2[1];
    var ref3 = (0,react.useState)(false), isBot = ref3[0], setIsBot = ref3[1];
    var isMobileScreen = (0,useMediaQuery/* default */.Z)({
        queryType: "mobile"
    });
    var router = (0,next_router.useRouter)();
    var ref4 = (0,react.useState)(""), currentCityText = ref4[0], setCurrentCityText = ref4[1];
    var query = router.query;
    var resultsHeaderRef = (0,react.useRef)(null);
    var sendGAandMoEngageEvent = (0,_services/* useEventTrackerService */.fQ)().sendGAandMoEngageEvent;
    /***
     * States
     */ var ref5 = (0,react.useState)(false), isSrcSearchVisible = ref5[0], setisSrcSearchVisible = ref5[1];
    var ref6 = (0,react.useState)(false), isDestSearchVisible = ref6[0], setisDestSearchVisible = ref6[1];
    var ref7 = (0,react.useState)(false), isEditSearchModalVisible = ref7[0], setisEditSearchModalVisible = ref7[1];
    var ref8 = (0,react.useState)(false), showOverlay = ref8[0], setshowOverlay = ref8[1];
    var ref9 = (0,react.useState)(), totalParams = ref9[0], setTotalParams = ref9[1];
    var ref10 = (0,react.useState)(), numOfParamsReady = ref10[0], updateNumOfParamsReady = ref10[1];
    var ref11 = (0,react.useState)(fetchOnClient), isLoadingData = ref11[0], setIsLoadingData = ref11[1];
    var ref12 = (0,react.useState)(false), isSearchCardMinimized = ref12[0], setIsSearchCardMinimized = ref12[1];
    var ref13 = (0,react.useState)(false), zoomInOut = ref13[0], setZoomInOut = ref13[1];
    var onStickyStateChanged = function(param) {
        var status = param.status;
        if (!zoomInOut) {
            setIsSearchCardMinimized(status === 1 || status === 2);
        }
    };
    var ref14 = (0,react.useState)((searchResults === null || searchResults === void 0 ? void 0 : searchResults.data) || Array(12).fill(undefined)), data = ref14[0], setData = ref14[1];
    var ref15 = (0,react.useState)(searchResults === null || searchResults === void 0 ? void 0 : searchResults.total_records), totalRecords = ref15[0], setTotalRecords = ref15[1];
    var ref16 = (0,react.useState)(1), currentPage = ref16[0], setcurrentPage = ref16[1];
    var ref17 = (0,react.useState)(5), pagesCount = ref17[0], setpagesCount = ref17[1];
    var ref18 = (0,react.useState)("location"), searchBy = ref18[0], setSearchBy = ref18[1];
    var ref19 = (0,react.useState)(), src = ref19[0], setSrc = ref19[1];
    var ref20 = (0,react.useState)(), dest = ref20[0], setDest = ref20[1];
    var ref21 = (0,react.useState)(""), nameSearchVal = ref21[0], setNameSearchVal = ref21[1];
    var ref22 = (0,react.useState)({}), selectedDestQuickFilter = ref22[0], updateSelectedDestQuickFilter = ref22[1];
    var ref23 = (0,useSearch/* usePlaceSearch */.A)({
        locationParamsOption: {
            source: city_search_service/* LocationSearchSource.TransporterProfile */.T5.TransporterProfile
        }
    }), onSrcSearchInput = ref23.onSearchInput, srcSearchOptions = ref23.searchOptions;
    var ref24 = (0,useSearch/* useStateSearch */.k)({
        locationParamsOption: {
            source: city_search_service/* LocationSearchSource.TransporterProfile */.T5.TransporterProfile
        }
    }), onDestSearchInput = ref24.onSearchInput, destSearchOptions = ref24.searchOptions;
    var isLoggedIn = Boolean(isPhoneVerified && companyId);
    var ref25 = useTransporterSearch(), transporterSearch = ref25.mutate;
    (0,react.useEffect)(function() {
        if (typeof navigator !== "undefined") {
            setIsBot(BOT_USER_AGENT_PATTERN.test(navigator.userAgent));
        }
    }, []);
    var checkRestrictedEvent = function(name) {
        switch(name){
            case "citySearchCount":
            case "transporterSearchCount":
                {
                    var count = Number((eventCounts === null || eventCounts === void 0 ? void 0 : eventCounts[name]) || 0);
                    return count >= 3;
                }
            case "pagination":
                {
                    return true;
                }
            default:
                {
                    return false;
                }
        }
    };
    var checkAndHandleGuestUserRestriction = function(name) {
        if (!companyId) {
            if (checkRestrictedEvent(name)) {
                router === null || router === void 0 ? void 0 : router.push({
                    hash: "#Login"
                });
                return false;
            }
            updateEventCount === null || updateEventCount === void 0 ? void 0 : updateEventCount(name);
        }
        return true;
    };
    var navigate = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var searchBy, _src, srcCityNameFromDescription, dest, nameSearchVal, currPage, arr, ref, ref1, ref2, ref3, ref4, ref5, ref6, tempObj, ref7, ref8, ref9, ref10, ref11, ref12, tempObj1, ref13, ref14, ref15, ref16, ref17, ref18, ref19, tempObj2, tempObj3, tempObj4, tempObj5;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (checkAndHandleGuestUserRestriction === null || checkAndHandleGuestUserRestriction === void 0 ? void 0 : checkAndHandleGuestUserRestriction("transporterSearchCount")) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        _ctx.next = 4;
                        return (0,getCurrentState/* getCurrentState */.M)(setSearchBy);
                    case 4:
                        searchBy = _ctx.sent;
                        _ctx.next = 7;
                        return (0,getCurrentState/* getCurrentState */.M)(setSrc);
                    case 7:
                        _src = _ctx.sent;
                        srcCityNameFromDescription = (_src === null || _src === void 0 ? void 0 : _src.city) || removeTextAfterComma(_src === null || _src === void 0 ? void 0 : _src.name) || "";
                        setCurrentCityText(srcCityNameFromDescription);
                        _ctx.next = 12;
                        return (0,getCurrentState/* getCurrentState */.M)(setDest);
                    case 12:
                        dest = _ctx.sent;
                        _ctx.next = 15;
                        return (0,getCurrentState/* getCurrentState */.M)(setNameSearchVal);
                    case 15:
                        nameSearchVal = _ctx.sent;
                        _ctx.next = 18;
                        return (0,getCurrentState/* getCurrentState */.M)(setcurrentPage);
                    case 18:
                        currPage = _ctx.sent;
                        setTotalParams(undefined);
                        updateNumOfParamsReady(undefined);
                        if (searchBy === "location") {
                            arr = query.params || [];
                            if ((_src === null || _src === void 0 ? void 0 : _src.place_id) && ((dest === null || dest === void 0 ? void 0 : dest.state_id) || (dest === null || dest === void 0 ? void 0 : dest.id))) {
                                ;
                                setisSrcSearchVisible(false);
                                setisDestSearchVisible(false);
                                setisEditSearchModalVisible(false);
                                tempObj = {
                                    p: "".concat(currPage)
                                };
                                arr[0] = (ref = "".concat(srcCityNameFromDescription, "-to-").concat(dest.state || dest.name)) === null || ref === void 0 ? void 0 : (ref1 = ref.replace) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.call(ref, / /g, "-")) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.replace) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.call(ref2, /,/g, "-")) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.replace) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.call(ref4, /--/g, "-")) === null || ref6 === void 0 ? void 0 : ref6.toLowerCase();
                                router.query.params = arr;
                                router.push({
                                    pathname: router.pathname,
                                    query: (0,src_object_spread/* default */.Z)({}, router.query, tempObj)
                                }, undefined, {
                                    shallow: true
                                });
                            } else if (_src === null || _src === void 0 ? void 0 : _src.place_id) {
                                ;
                                setisSrcSearchVisible(false);
                                setisDestSearchVisible(false);
                                setisEditSearchModalVisible(false);
                                tempObj1 = {
                                    p: "".concat(currPage)
                                };
                                arr[0] = srcCityNameFromDescription === null || srcCityNameFromDescription === void 0 ? void 0 : (ref7 = srcCityNameFromDescription.replace) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.call(srcCityNameFromDescription, / /g, "-")) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.replace) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.call(ref8, /,/g, "-")) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.replace) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.call(ref10, /--/g, "-")) === null || ref12 === void 0 ? void 0 : ref12.toLowerCase();
                                router.query.params = arr;
                                router.push({
                                    pathname: router.pathname,
                                    query: (0,src_object_spread/* default */.Z)({}, router.query, tempObj1)
                                }, undefined, {
                                    shallow: true
                                });
                            } else if ((dest === null || dest === void 0 ? void 0 : dest.state_id) || (dest === null || dest === void 0 ? void 0 : dest.id)) {
                                ;
                                setisSrcSearchVisible(false);
                                setisDestSearchVisible(false);
                                setisEditSearchModalVisible(false);
                                tempObj2 = {
                                    p: "".concat(currPage)
                                };
                                arr[0] = (ref14 = "for-".concat((ref13 = dest.state || (dest === null || dest === void 0 ? void 0 : dest.name)) === null || ref13 === void 0 ? void 0 : ref13.toLowerCase())) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.replace) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.call(ref14, / /g, "-")) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.replace) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.call(ref16, /,/g, "-")) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.replace) === null || ref19 === void 0 ? void 0 : ref19.call(ref18, /--/g, "-");
                                router.query.params = arr;
                                router.push({
                                    pathname: router.pathname,
                                    query: (0,src_object_spread/* default */.Z)({}, router.query, tempObj2)
                                }, undefined, {
                                    shallow: true
                                });
                            } else {
                                setisSrcSearchVisible(false);
                                setisDestSearchVisible(false);
                                setisEditSearchModalVisible(false);
                                tempObj3 = {
                                    p: "".concat(currPage)
                                };
                                router.query.params = [];
                                router.push({
                                    pathname: router.pathname,
                                    query: (0,src_object_spread/* default */.Z)({}, router.query, tempObj3)
                                }, undefined, {
                                    shallow: true
                                });
                            }
                        } else {
                            if (nameSearchVal === null || nameSearchVal === void 0 ? void 0 : nameSearchVal.trim()) {
                                setisSrcSearchVisible(false);
                                setisDestSearchVisible(false);
                                setisEditSearchModalVisible(false);
                                tempObj4 = {
                                    p: "".concat(currPage)
                                };
                                router.query.params = [
                                    "name",
                                    "".concat(nameSearchVal || "")
                                ];
                                router.push({
                                    pathname: router.pathname,
                                    query: (0,src_object_spread/* default */.Z)({}, router.query, tempObj4)
                                }, undefined, {
                                    shallow: true
                                });
                            } else {
                                setisSrcSearchVisible(false);
                                setisDestSearchVisible(false);
                                setisEditSearchModalVisible(false);
                                tempObj5 = {
                                    p: "".concat(currPage)
                                };
                                router.query.params = [
                                    "name"
                                ];
                                router.push({
                                    pathname: router.pathname,
                                    query: (0,src_object_spread/* default */.Z)({}, router.query, tempObj5)
                                }, undefined, {
                                    shallow: true
                                });
                            }
                        }
                        setShouldExecuteApi(true);
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function navigate() {
            return _ref.apply(this, arguments);
        };
    }();
    var getAndSetData = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(_searchBy, _nameSearchVal) {
            var currentPage, ref, t1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (shouldExecuteApi) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        setshowOverlay(false);
                        _ctx.next = 5;
                        return (0,getCurrentState/* getCurrentState */.M)(setcurrentPage);
                    case 5:
                        currentPage = _ctx.sent;
                        if (currentPage <= pagesCount - 1) {
                            ;
                            setData(Array(12).fill(undefined));
                            setIsLoadingData(true);
                            t1 = Date.now();
                            transporterSearch((0,src_object_spread/* default */.Z)({
                                page: currentPage
                            }, (_searchBy || searchBy) === "name" && ((ref = _nameSearchVal || nameSearchVal) === null || ref === void 0 ? void 0 : ref.trim()) ? {
                                name: _nameSearchVal || nameSearchVal
                            } : {
                                sourcePlaceId: src === null || src === void 0 ? void 0 : src.place_id,
                                routeStateIds: (dest === null || dest === void 0 ? void 0 : dest.id) ? [
                                    dest === null || dest === void 0 ? void 0 : dest.id
                                ] : undefined
                            }), {
                                onSuccess: function() {
                                    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                                        var t2;
                                        return runtime_default().wrap(function _callee$(_ctx) {
                                            while(1)switch(_ctx.prev = _ctx.next){
                                                case 0:
                                                    if (!data) {
                                                        _ctx.next = 9;
                                                        break;
                                                    }
                                                    (data === null || data === void 0 ? void 0 : data.total_pages) && setpagesCount((data === null || data === void 0 ? void 0 : data.total_pages) > 4 ? 5 : (data === null || data === void 0 ? void 0 : data.total_pages) + 1);
                                                    (data === null || data === void 0 ? void 0 : data.total_records) && setTotalRecords(data === null || data === void 0 ? void 0 : data.total_records);
                                                    t2 = Date.now();
                                                    if (!(t2 - t1 < 500)) {
                                                        _ctx.next = 7;
                                                        break;
                                                    }
                                                    _ctx.next = 7;
                                                    return (0,sleep/* sleep */._)(500 - (t2 - t1));
                                                case 7:
                                                    if (data.data) {
                                                        (0,user_analytics_service/* ga4sendEvent */.zs)("Directory_search_success_by_name_web", {
                                                            value: 1
                                                        });
                                                        setData(data.data.map(function(_param) {
                                                            var _routes = _param.routes, _connections = _param.connections, result = (0,_object_without_properties/* default */.Z)(_param, [
                                                                "routes",
                                                                "connections"
                                                            ]);
                                                            return result;
                                                        }));
                                                    } else {
                                                        (0,user_analytics_service/* ga4sendEvent */.zs)("Directory_search_success_by_name_web", {
                                                            value: 0
                                                        });
                                                        setshowOverlay(true);
                                                    }
                                                    setIsLoadingData(false);
                                                case 9:
                                                    setShouldExecuteApi(false);
                                                case 10:
                                                case "end":
                                                    return _ctx.stop();
                                            }
                                        }, _callee);
                                    }));
                                    return function(data) {
                                        return _ref.apply(this, arguments);
                                    };
                                }(),
                                onError: function() {}
                            });
                        } else {
                            setshowOverlay(true);
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getAndSetData(_searchBy, _nameSearchVal) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClick = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(page) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (checkAndHandleGuestUserRestriction === null || checkAndHandleGuestUserRestriction === void 0 ? void 0 : checkAndHandleGuestUserRestriction("pagination")) {
                            setcurrentPage(page);
                            if (page < pagesCount) {
                                navigate();
                            } else {
                                setshowOverlay(true);
                                 true && window.scrollTo({
                                    left: 0,
                                    top: 0,
                                    behavior: "smooth"
                                });
                            }
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleClick(page) {
            return _ref.apply(this, arguments);
        };
    }();
    var onChangeSearchBy = function(e) {
        if (e.target.value.includes("name")) (0,user_analytics_service/* ga4sendEvent */.zs)("Directory_search_transporter_type_web", {
            value: 0
        });
        else (0,user_analytics_service/* ga4sendEvent */.zs)("Directory_search_transporter_type_web", {
            value: 1
        });
        if (e.target.checked) {
            setSearchBy(e.target.value);
            setcurrentPage(1);
            setpagesCount(5);
            navigate();
        }
    };
    var onSelectSrc = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(selectedCity) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setSrc(selectedCity);
                        setcurrentPage(1);
                        setpagesCount(5);
                        navigate();
                        sendGAandMoEngageEvent({
                            name: constants/* GA4EventNames.TRANSPORT_DIRECTORY.transport_directory_source_city_entered */.wQR.TRANSPORT_DIRECTORY.transport_directory_source_city_entered,
                            data: {
                                source_screen: "transport_directory"
                            }
                        });
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSelectSrc(selectedCity) {
            return _ref.apply(this, arguments);
        };
    }();
    var onClearSrc = function() {
        setSrc(undefined);
        setcurrentPage(1);
        setpagesCount(5);
        navigate();
    };
    var onSelectDest = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(selectedState) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setDest(selectedState);
                        setcurrentPage(1);
                        setpagesCount(5);
                        navigate();
                        sendGAandMoEngageEvent({
                            name: constants/* GA4EventNames.TRANSPORT_DIRECTORY.transport_directory_destination_city_entered */.wQR.TRANSPORT_DIRECTORY.transport_directory_destination_city_entered,
                            data: {
                                source_screen: "transport_directory"
                            }
                        });
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSelectDest(selectedState) {
            return _ref.apply(this, arguments);
        };
    }();
    var onInputNameSearch = function(e) {
        setNameSearchVal(e.target.value);
        setpagesCount(5);
        setcurrentPage(1);
        sendGAandMoEngageEvent({
            name: constants/* GA4EventNames.TRANSPORT_DIRECTORY.transport_directory_search_by_name_entered */.wQR.TRANSPORT_DIRECTORY.transport_directory_search_by_name_entered,
            data: {
                source_screen: "transport_directory"
            }
        });
    };
    var nameSearchDebounceVal = (0,useDebounce/* useDebounce */.N)(nameSearchVal, 600);
    (0,react.useEffect)(function() {
        if (searchBy == "name" && nameSearchDebounceVal !== null && nameSearchDebounceVal !== undefined) {
            navigate();
        }
    }, [
        nameSearchDebounceVal,
        searchBy
    ]);
    var onClearName = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setNameSearchVal("");
                        setcurrentPage(1);
                        setpagesCount(5);
                        navigate();
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClearName() {
            return _ref.apply(this, arguments);
        };
    }();
    var onClickUpdateSearch = function(param) {
        var searchBy = param.searchBy, src = param.src, dest = param.dest, name = param.name;
        setSearchBy(searchBy);
        if (searchBy === "location") {
            setSrc(src);
            setDest(dest);
        } else {
            setNameSearchVal(name);
        }
        setcurrentPage(1);
        setpagesCount(5);
        navigate();
    };
    (0,react.useEffect)(function() {
        // if (scrollPos !== 0) {
        //     if (location?.state?.isEditSearchModalVisible) {
        //     } else if (location?.state?.isSrcSearchVisible || location?.state?.isDestSearchVisible) {
        //         window.scrollTo(0, 0);
        //     } else {
        //         window.scrollTo({ left: 0, top: +getHeightByViewPort(74 - 55).slice(0, -2), behavior: "smooth" });
        //     }
        // }
        // const { p } = qs.parse(location.search);
        setcurrentPage(+(query.p || 1));
        var paths = router.query.params ? router.query.params[0] : undefined;
        if (paths === null || paths === void 0 ? void 0 : paths.includes("name")) {
            setSearchBy("name");
            setNameSearchVal(router.query.params[1]);
            getAndSetData("name", router.query.params[1]);
        } else {
            setSearchBy("location");
            var src, dest;
            var locationParam = router.query.params ? router.query.params[0] : undefined;
            if (locationParam === null || locationParam === void 0 ? void 0 : locationParam.includes("-to-")) {
                var ref;
                ref = (0,_sliced_to_array/* default */.Z)(locationParam.split("-to-").map(function(p) {
                    return p.replace(/-/g, " ");
                }), 2), src = ref[0], dest = ref[1], ref;
            } else if ((locationParam === null || locationParam === void 0 ? void 0 : locationParam.includes("for-")) && router.asPath.includes("/for")) {
                dest = locationParam.split("for-")[1].replace(/-/g, " ");
            } else {
                src = locationParam === null || locationParam === void 0 ? void 0 : locationParam.replace(/-/g, " ");
            }
            setpagesCount(5);
            setTotalParams((!!src ? 1 : 0) + (!!dest ? 1 : 0));
            updateNumOfParamsReady(0);
            if (shouldExecuteApi) {
                src ? onSrcSearchInput(src) : setSrc(undefined);
                dest ? onDestSearchInput(dest) : setDest(undefined);
            }
        }
    }, [
        router.query
    ]);
    (0,react.useEffect)(function() {
        if ((srcSearchOptions === null || srcSearchOptions === void 0 ? void 0 : srcSearchOptions.length) > 0) {
            var resolvedSrc = srcSearchOptions[0];
            setSrc(resolvedSrc);
            setCurrentCityText((resolvedSrc === null || resolvedSrc === void 0 ? void 0 : resolvedSrc.city) || removeTextAfterComma(resolvedSrc === null || resolvedSrc === void 0 ? void 0 : resolvedSrc.name) || "");
            updateNumOfParamsReady(function(state) {
                return (state || 0) + 1;
            });
        }
    }, [
        srcSearchOptions
    ]);
    (0,react.useEffect)(function() {
        if (destSearchOptions === null || destSearchOptions === void 0 ? void 0 : destSearchOptions[0]) {
            setDest(destSearchOptions[0]);
            updateSelectedDestQuickFilter(destSearchOptions[0]);
            updateNumOfParamsReady(function(state) {
                return (state || 0) + 1;
            });
        }
    }, [
        destSearchOptions
    ]);
    (0,react.useEffect)(function() {
        if (numOfParamsReady !== undefined && totalParams !== undefined && numOfParamsReady === totalParams) {
            getAndSetData();
        }
    }, [
        numOfParamsReady
    ]);
    var pageLoadParam = (0,getPageLoadSourceUTMParam/* getPageLoadSourceUTMParam */.LE)({
        urlQueryParams: router.query,
        utmParamObj: getPageLoadSourceUTMParam/* transporterUtmParam */.vh
    });
    (function() {
        if (true) {
            window.addEventListener("resize", function() {
                if (window.devicePixelRatio > 2 || window.devicePixelRatio < 2) {
                    setZoomInOut(true);
                } else {
                    setZoomInOut(false);
                }
            });
        }
    })();
    var city = searchBy === "location" && query.params !== undefined ? ((ref = query.params) === null || ref === void 0 ? void 0 : ref[0]) && (0,capitalize/* capitalize */.k)(query.params[0]) : "";
    var IN_CITY_TEXT = "".concat(city ? "in " + city : "");
    var META_TITLE = "Top Transporters ".concat(IN_CITY_TEXT ? IN_CITY_TEXT : "Directory in India", " | Book Online Transport Service");
    var META_DESCRIPTION = city ? "Discover trustworthy transporters ".concat(IN_CITY_TEXT, " for efficient and secure logistics solutions. Vahak provides a platform to connect with reliable transportation services tailored to your needs.") : "Join India's largest verified transporter directory. Connect and book transporters online on Vahak for transportation services anytime, anywhere. Enjoy a seamless and trusted transport community.";
    var ref26 = (0,react.useState)(isMobileScreen ? "100px" : "105px"), topPadding = ref26[0], setTopPadding = ref26[1];
    var ref27 = (0,react.useState)(0), stickyHeaderTop = ref27[0], setStickyHeaderTop = ref27[1];
    (0,react.useEffect)(function() {
        if (isPhoneVerified && companyId) {
            setTopPadding("0px");
            setStickyHeaderTop(0);
        } else if (isPhoneVerified && !companyId) {
            setTopPadding(isMobileScreen ? "100px" : "105px");
            setStickyHeaderTop(isMobileScreen ? 100 : 105);
        } else {
            setTopPadding(isMobileScreen ? "55px" : "65px");
            setStickyHeaderTop(isMobileScreen ? 0 : 65);
        }
    }, [
        isPhoneVerified,
        companyId,
        isMobileScreen
    ]);
    (0,react.useEffect)(function() {
        if (router.isReady) {
            var params = router.query.params;
            if (Array.isArray(params)) {
                params = params === null || params === void 0 ? void 0 : params.map(function(param) {
                    var ref, ref1, ref2, ref3, ref4;
                    return param === null || param === void 0 ? void 0 : (ref = param.replace) === null || ref === void 0 ? void 0 : (ref1 = ref.call(param, / /g, "-")) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.replace) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.call(ref1, /,/g, "-")) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.replace) === null || ref4 === void 0 ? void 0 : ref4.call(ref3, /--/g, "-");
                });
            }
            router.push({
                query: {
                    params: params
                }
            }, undefined, {
                shallow: false
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        router.isReady
    ]);
    var sourceCityToUseForSeoContent = currentCityText;
    var ref28;
    var shouldIndex = ((ref28 = totalRecords !== null && totalRecords !== void 0 ? totalRecords : searchResults === null || searchResults === void 0 ? void 0 : searchResults.total_records) !== null && ref28 !== void 0 ? ref28 : 0) >= 5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMetaTags/* default */.Z, {
                title: META_TITLE,
                description: META_DESCRIPTION,
                shouldBeIndexed: shouldIndex,
                canonicalUrl: "https://www.vahak.in".concat(routeStrings/* ROUTES.transporters.getUrl */.Z.transporters.getUrl(sourceCityToUseForSeoContent)),
                ogUrl: "https://www.vahak.in".concat(routeStrings/* ROUTES.transporters.getUrl */.Z.transporters.getUrl(sourceCityToUseForSeoContent)),
                ogImgSrc: "https://d1rgemtytdlz2g.cloudfront.net/web_og_image_jan_22.png",
                ogImgAltText: "Connect with India's verified transport services through Vahaks online Transport Directory. Search for logistics company, move your goods easily and get them delivered anywhere in India. Connect now with transport services in ".concat(searchBy === "location" && query.params !== undefined ? query.params && query.params[0] : "India"),
                schemaOrgJsonUrl: routeStrings/* ROUTES.transporters.getUrl */.Z.transporters.getUrl(sourceCityToUseForSeoContent),
                breadcrumbList: searchBy === "location" && query.params !== undefined ? (0,breadcrumbs_constants/* breadcrumbsConstants */.U)({
                    city: query.params[0]
                }).transportDirectoryLocation : (0,breadcrumbs_constants/* breadcrumbsConstants */.U)({}).transportDirectory,
                faqList: sourceCityToUseForSeoContent ? getFaqListByCity(sourceCityToUseForSeoContent).faqList : []
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                style: {
                    paddingBottom: 0,
                    position: "relative",
                    paddingTop: topPadding
                },
                className: classnames_default()(isMobileScreen ? "mobilePage" : "desktopPage"),
                children: (currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.status) !== "loading" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        isMobileScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Sticky/* default */.Z, {
                            onStateChange: onStickyStateChanged,
                            enabled: true,
                            bottomBoundary: "#resultsContainer",
                            top: 55,
                            innerZ: 99,
                            className: (search_module_default()).stickyOuterWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_Mobile, {
                                isSearchCardMinimized: isSearchCardMinimized,
                                topContainerClassName: classnames_default()((search_module_default()).topContainer, "topContainer", searchBy === "name" && (search_module_default()).searchByNameTopContainer, isSearchCardMinimized && "sticky", isSearchCardMinimized && (search_module_default()).sticky),
                                searchCardClassName: classnames_default()("searchCardContainer", (search_module_default()).searchCardContainer),
                                searchBy: searchBy,
                                onChangeSearchBy: onChangeSearchBy,
                                src: src,
                                onSelectSrc: onSelectSrc,
                                onClearSrc: onClearSrc,
                                dest: dest,
                                onSelectDest: onSelectDest,
                                selectedDestQuickFilter: selectedDestQuickFilter,
                                nameSearchVal: nameSearchVal,
                                onInputNameSearch: onInputNameSearch,
                                onClearName: onClearName,
                                onClickUpdateSearch: onClickUpdateSearch,
                                isSrcSearchVisible: isSrcSearchVisible,
                                setisSrcSearchVisible: setisSrcSearchVisible,
                                isDestSearchVisible: isDestSearchVisible,
                                setisDestSearchVisible: setisDestSearchVisible,
                                isEditSearchModalVisible: isEditSearchModalVisible,
                                setisEditSearchModalVisible: setisEditSearchModalVisible,
                                srcParam: (0,capitalize/* capitalize */.k)(sourceCityToUseForSeoContent !== null && sourceCityToUseForSeoContent !== void 0 ? sourceCityToUseForSeoContent : "")
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Sticky/* default */.Z, {
                            onStateChange: onStickyStateChanged,
                            enabled: true,
                            bottomBoundary: "#resultsContainer",
                            // top={"#resultsContainer"}
                            // top={0}
                            top: stickyHeaderTop,
                            innerZ: !isSearchCardMinimized ? 1 : 99,
                            className: classnames_default()((search_module_default()).transporter_sticky_wrapper, isSearchCardMinimized && (search_module_default()).active),
                            children: !isSearchCardMinimized ? /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_Desktop, {
                                isSearchCardMinimized: false,
                                topContainerClassName: classnames_default()("topContainer"),
                                coverClassName: classnames_default()("cover"),
                                searchCardClassName: "searchCardContainer",
                                searchBy: searchBy,
                                onChangeSearchBy: onChangeSearchBy,
                                src: src,
                                onSelectSrc: onSelectSrc,
                                dest: dest,
                                onSelectDest: onSelectDest,
                                selectedDestQuickFilter: selectedDestQuickFilter,
                                nameSearchVal: nameSearchVal,
                                onInputNameSearch: onInputNameSearch,
                                onClearName: onClearName,
                                srcParam: (0,capitalize/* capitalize */.k)(sourceCityToUseForSeoContent !== null && sourceCityToUseForSeoContent !== void 0 ? sourceCityToUseForSeoContent : "")
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(search_DesktopSearchCard, {
                                isSearchCardMinimized: true,
                                searchBy: searchBy,
                                onChangeSearchBy: onChangeSearchBy,
                                src: src,
                                onSelectSrc: onSelectSrc,
                                dest: dest,
                                onSelectDest: onSelectDest,
                                selectedDestQuickFilter: selectedDestQuickFilter,
                                nameSearchVal: nameSearchVal,
                                onInputNameSearch: onInputNameSearch,
                                onClearName: onClearName
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()(isMobileScreen ? "transporterSearch__results__mobile" : "transporterSearch__results__desktop", isSearchCardMinimized ? (search_module_default()).transporterSearchResult : ""),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mainDivAlign",
                                            style: {
                                                marginTop: isMobileScreen ? "33px" : "40px",
                                                marginBottom: isMobileScreen ? "18px" : "12px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: (search_module_default()).transporters_heading,
                                                    style: {
                                                        fontSize: isMobileScreen ? (0,getRemValue/* getRemValue */.T)(16) : (0,getRemValue/* getRemValue */.T)(20),
                                                        fontFamily: "Inter-Bold",
                                                        lineHeight: isMobileScreen ? "20px" : "28px",
                                                        letterSpacing: isMobileScreen ? (0,getRemValue/* getRemValue */.T)(-0.16) : (0,getRemValue/* getRemValue */.T)(-0.22)
                                                    },
                                                    ref: resultsHeaderRef,
                                                    children: !isLoadingData ? isMobileScreen ? t("transporter_profile_section.title_mobile") : src && searchBy === "location" ? "Showing ".concat(totalRecords || "", " Transporters around ").concat(sourceCityToUseForSeoContent) : t("transporter_profile_section.title_desktop") : /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.ZP, {
                                                        width: isMobileScreen ? "150px" : "350px"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        color: "#202124",
                                                        fontSize: isMobileScreen ? (0,getRemValue/* getRemValue */.T)(11) : (0,getRemValue/* getRemValue */.T)(16),
                                                        letterSpacing: isMobileScreen ? (0,getRemValue/* getRemValue */.T)(1.98) : (0,getRemValue/* getRemValue */.T)(3.96),
                                                        marginLeft: "auto",
                                                        marginRight: isMobileScreen ? "10px" : "12px",
                                                        lineHeight: isMobileScreen ? "12px" : "23px",
                                                        fontFamily: "var(--font-medium)"
                                                    },
                                                    children: !isLoadingData ? "".concat(currentPage, "/").concat(pagesCount) : /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.ZP, {
                                                        width: "50px"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(pagination/* default */.Z, {
                                                    currentPage: currentPage,
                                                    pagesCount: pagesCount,
                                                    handleClick: handleClick,
                                                    isMobile: isMobileScreen
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (search_module_default()).searchedCityDesc,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowMoreText/* default */.Z, {
                                                limit: isBot ? getFaqListByCity(sourceCityToUseForSeoContent !== null && sourceCityToUseForSeoContent !== void 0 ? sourceCityToUseForSeoContent : "India").titleH1Desc.length : 100,
                                                truncatedEnding: "",
                                                more: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    weight: "semibold",
                                                    children: "Read More +"
                                                }),
                                                text: getFaqListByCity(sourceCityToUseForSeoContent !== null && sourceCityToUseForSeoContent !== void 0 ? sourceCityToUseForSeoContent : "India").titleH1Desc
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResultsContainer, {
                                            data: data,
                                            className: classnames_default()("cardContainer", showOverlay && "TransporterSearch__Overlay"),
                                            id: "resultsContainer"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "alignPaginationDiv",
                                            id: "bottomPagination",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomPagination/* default */.Z, {
                                                currentPage: currentPage,
                                                pagesCount: pagesCount,
                                                handleClick: handleClick,
                                                isMobile: isMobileScreen
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "d-flex justify-content-center",
                    style: {
                        height: "80vh",
                        alignItems: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "spinner-border",
                        role: "status",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "sr-only",
                            children: "Loading..."
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (search_module_default()).ctaSection,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (search_module_default()).contentContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (search_module_default()).content,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        as: "h3",
                                        size: "xxl",
                                        mSize: "m",
                                        color: colors/* default.WHITE */.Z.WHITE,
                                        children: "Get Premium Features & Priority Support!"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    size: "m",
                                    onClick: function() {
                                        router.push(routeStrings/* ROUTES.membershipUpgrade.getUrl */.Z.membershipUpgrade.getUrl());
                                    },
                                    color: "tertiary",
                                    children: "Upgrade Now!"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                            src: "online-truck-booking_desktop.png",
                            alt: "cta image",
                            layout: "fixed",
                            width: isMobileScreen ? 236 : 440,
                            height: isMobileScreen ? 135 : 255
                        })
                    ]
                })
            }),
            !!sourceCityToUseForSeoContent && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: classnames_default()("container", (search_module_default()).cityExtendedDesc),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(helper_CityDescription, {
                    city: sourceCityToUseForSeoContent
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(cta_banner_CTABanner, {
                href: constants_link/* PLAYSTORE_URLS.transporterSearchPage */.HS.transporterSearchPage,
                title: t("header_filter_section.bottom_cta.heading")
            }),
            !isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MandateServiceType/* default */.Z, {
                isLoggedIn: isLoggedIn,
                initialServiceType: serviceType,
                source: "transport_directory"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
        ]
    });
};
/* harmony default export */ var search_Search = (Search_Search);
var removeTextAfterComma = function(text) {
    return text === null || text === void 0 ? void 0 : text.replace(/,.*/, "");
};

// EXTERNAL MODULE: ./constants/route-constants.ts
var route_constants = __webpack_require__(50837);
;// CONCATENATED MODULE: ./pages/transporters/[[...params]].tsx



var __N_SSG = true;
function TransporterSearch() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(search_Search, {
        route: route_constants/* TRANSPORT_DIRECTORY */.fN
    });
};


/***/ }),

/***/ 73045:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"TransporterCardTopSection_main___nKrq","profileDetailsRow":"TransporterCardTopSection_profileDetailsRow__kKNa4","profileImageCol":"TransporterCardTopSection_profileImageCol__feBhJ","image":"TransporterCardTopSection_image__OeGY5","profileTextCol":"TransporterCardTopSection_profileTextCol__2AKyD","oneLineInfo":"TransporterCardTopSection_oneLineInfo__0RbDV","name":"TransporterCardTopSection_name___Rkz9","jobTitle":"TransporterCardTopSection_jobTitle__OgsbC","location":"TransporterCardTopSection_location__V06G3","ratingsCol":"TransporterCardTopSection_ratingsCol__sabry","connections":"TransporterCardTopSection_connections__eU_VU","views":"TransporterCardTopSection_views__vciUE","years":"TransporterCardTopSection_years__D_iaW","dot":"TransporterCardTopSection_dot__YrEmx","nameEllipsis":"TransporterCardTopSection_nameEllipsis__ntxA4","jobTitleEllipsis":"TransporterCardTopSection_jobTitleEllipsis__7SGDY","alignCenter":"TransporterCardTopSection_alignCenter__vNuF6"};

/***/ }),

/***/ 46953:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"TransporterCard_cardWrapper___l2W5"};

/***/ }),

/***/ 67507:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ctaBannerWrap":"CTABanner_ctaBannerWrap__PSysd","CtaImage":"CTABanner_CtaImage__D2pNK","desktopPage":"CTABanner_desktopPage__8PajC","mobilePage":"CTABanner_mobilePage__XxdQf","ctaBanner":"CTABanner_ctaBanner___PzXA","ctaRow":"CTABanner_ctaRow__jbe17","text":"CTABanner_text__BZ8Tk","ctaButton":"CTABanner_ctaButton__uSHAD","imgBox":"CTABanner_imgBox__vX0sC"};

/***/ }),

/***/ 40769:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ServiceTypeModalBodyWrapper":"MandateServiceType_ServiceTypeModalBodyWrapper__rb89r","serviceTypeWrapper":"MandateServiceType_serviceTypeWrapper__bShG9","serviceTypeCard":"MandateServiceType_serviceTypeCard__yyZ0e","active":"MandateServiceType_active__8FCyh"};

/***/ }),

/***/ 91932:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"CityDescription_main__0daAi","desc":"CityDescription_desc__rAi_6","faq":"CityDescription_faq__x1LAV","faqTitle":"CityDescription_faqTitle__2_RZ_","descList":"CityDescription_descList__cVwP1"};

/***/ }),

/***/ 45446:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btn":"CloseBtn_btn__Dk34n"};

/***/ }),

/***/ 67005:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dest_search_quick_filter":"DesktopSearchCard_dest_search_quick_filter__MnF1x","nameSearch":"DesktopSearchCard_nameSearch__VSE9F","srcSearchLabel":"DesktopSearchCard_srcSearchLabel__yWS2d","activeSrc":"DesktopSearchCard_activeSrc__5oSo_","dirtySrc":"DesktopSearchCard_dirtySrc__FB08Q","selectedStateFilterPill":"DesktopSearchCard_selectedStateFilterPill__RNSeU"};

/***/ }),

/***/ 16313:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"EditSearchModal_container__eHQeS","content":"EditSearchModal_content__BxUKs","body":"EditSearchModal_body__E1WvD","searchBy":"EditSearchModal_searchBy__3ijAf","searchByRadioBtns":"EditSearchModal_searchByRadioBtns__2KS_b","radioBtn__input":"EditSearchModal_radioBtn__input__VYpxJ","radioBtn__label":"EditSearchModal_radioBtn__label__8bLI8","locationRadioBtn":"EditSearchModal_locationRadioBtn__MQWvM","nameRadioBtn":"EditSearchModal_nameRadioBtn__sRMpf","src":"EditSearchModal_src__bZ4v_","dest":"EditSearchModal_dest__Sn0Eq","nameSearch":"EditSearchModal_nameSearch__EVMTy","label":"EditSearchModal_label__oNHhd","srcSearchBtn__Text":"EditSearchModal_srcSearchBtn__Text__OeVqI","placeholder":"EditSearchModal_placeholder__mwa2I","dest_search_control":"EditSearchModal_dest_search_control__acIfJ","dest__quick_filter":"EditSearchModal_dest__quick_filter__Rzo3K","nameSearch__Container":"EditSearchModal_nameSearch__Container__edonh","search_icon_container":"EditSearchModal_search_icon_container__haeKa","search_icon":"EditSearchModal_search_icon__PNsl1","submitBtn":"EditSearchModal_submitBtn__DkuJT"};

/***/ }),

/***/ 8827:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"transporters__mobile_search__container":"MobileSearchCard_transporters__mobile_search__container__Yoe6u","minimized":"MobileSearchCard_minimized__6_t6v","transporters__mobile_search__source_search_btn":"MobileSearchCard_transporters__mobile_search__source_search_btn__haHRo","transporters__mobile_search__source_search_btn__text":"MobileSearchCard_transporters__mobile_search__source_search_btn__text__ijJUL","transporters__mobile_search__source_prefix":"MobileSearchCard_transporters__mobile_search__source_prefix__Q7GFD","transporters__mobile_search__dest_container":"MobileSearchCard_transporters__mobile_search__dest_container___yZho","transporters__mobile_search__dest_label":"MobileSearchCard_transporters__mobile_search__dest_label__t5g7W","dest_search_control":"MobileSearchCard_dest_search_control__9GV7X","dest__quick_filter":"MobileSearchCard_dest__quick_filter__x_A4q","dest_search_icon_container":"MobileSearchCard_dest_search_icon_container__EuP1i","dest_search_icon":"MobileSearchCard_dest_search_icon__8jHB_","editContainer":"MobileSearchCard_editContainer__sTi7c","nameEditContainer":"MobileSearchCard_nameEditContainer__yC6sd","currentSelections":"MobileSearchCard_currentSelections__hZJMU","selectedSrc":"MobileSearchCard_selectedSrc__urPC7","selectedDest":"MobileSearchCard_selectedDest__HCaiK","nameSearchVal__Container":"MobileSearchCard_nameSearchVal__Container__hmUBq","nameSearch":"MobileSearchCard_nameSearch__PdA1s","editBtn":"MobileSearchCard_editBtn__fjNtY","selectedStateFilterPill":"MobileSearchCard_selectedStateFilterPill__nMGgo"};

/***/ }),

/***/ 43154:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"QuickFilterPill_container__tw74l","selected":"QuickFilterPill_selected__0xjB0","prefix":"QuickFilterPill_prefix__BE7JI","suffix":"QuickFilterPill_suffix__7J2bY","mobile":"QuickFilterPill_mobile__q0gws","desktop":"QuickFilterPill_desktop__BVNW9"};

/***/ }),

/***/ 12753:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"transporters_heading":"search_transporters_heading__Sq2nD","ctaSection":"search_ctaSection__98EdO","contentContainer":"search_contentContainer__9DV3L","content":"search_content__1dkmd","topContainer":"search_topContainer__LrPeM","searchByNameTopContainer":"search_searchByNameTopContainer__0CkrL","sticky":"search_sticky__7pl_E","searchCardContainer":"search_searchCardContainer__eXmZ8","stickyOuterWrapper":"search_stickyOuterWrapper__Uyy5y","transporterSearchResult":"search_transporterSearchResult__70bWV","searchedCityDesc":"search_searchedCityDesc__ONSrx","cityExtendedDesc":"search_cityExtendedDesc__k7UaO","transporter_sticky_wrapper":"search_transporter_sticky_wrapper__QjYNr"};

/***/ }),

/***/ 3787:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardWrapperContainer":"searchResultsContainer_cardWrapperContainer__F_B5a","cardWrapper":"searchResultsContainer_cardWrapper__cDfTE"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4304,6090,5502,2181,72,5728,5736,6547,9774,2888,179], function() { return __webpack_exec__(78645); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);